// 法语
import frLocale from 'element-ui/lib/locale/lang/fr'


const fr = {
  // ============== 登陆页 start=============
  "登录": "Connexion",
  "退出": "Déconnexion",
  "账号": "Compte",
  "密码": "Mot de passe",
  "验证码": "Code de vérification",
  "请输入账号": "Veuillez saisir votre compte",
  "请输入密码": "Veuillez saisir votre mot de passe",
  "请输入验证码": "Veuillez saisir le code de vérification",
  "验证码不正确": "Code de vérification incorrect",
  "没有账号": "Pas de compte",
  "请": "Veuillez",
  "点击注册": "Cliquez pour vous inscrire",
  // ============== 登陆页 end  =============
  // =========== 首页 start==================
  "门店总量": "Total des magasins",
  "用户总量": "Nombre total d'utilisateurs",
  "营业总量": "Chiffre d'affaires total",
  "订单总量": "Volume total des commandes",
  "商品总量": "Nombre total d'inventaire",
  "销售总额": "Total des ventes",
  "元": "€",
  "预计收入": "Revenu estimé",
  "今日概况": "Résumé du jour",
  "销售额": "Volume des ventes",
  "支付订单数": "Commandes payées",
  "昨日": "Hier",
  "新增用户数": "Nouveaux utilisateurs",
  "新增商户": "Nouveaux commerçants",
  "下单用户数": "Utilisateurs passant des commandes",
  "待办事项": "Taches en attente",
  "请尽快处理，以免影响营业": "Veuillez traiter rapidement pour éviter d'impact sur les affaires",
  "待处理订单": "Commandes en traitement",
  "库存告急": "Urgence de stock",
  "商品排行榜": "Classement des produits les plus vendus",
  "销量": "Volume de ventes",
  "暂无上榜记录": "Aucun enregistrement en tête pour le moment",
  "成交额": "Volume de transactions",
  "成交量": "Nombre de transactions",
  "退单额": "Volume total des remboursements",
  "退单量": "Nombre de remboursements",

  // ========== 首页 end==================
  // ========== 建店必做 start=============
  "基本资料": "Informations de base",
  "编辑门店": "Modifier le magasin",
  "官方网站": "Site officiel",
  "门店服务": "Services du magasin",
  "服务与营业时间": "Services et heures d'ouverture",
  "桌码管理": "Gestion des codes de table",
  "收银台": "Caisse",
  "后厨": "Cuisine",
  "商品": "Marchandises",
  "添加商品": "Ajouter des marchandises",
  "网站": "Site web",
  "网站编辑": "édition du site web",
  "上一步": "Précédent",
  "保存": "Enregistrer",
  "下一步": "étape suivante",
  "提交失败": "échec de la soumission",
  "获取当前进度信息失败": "échec de l'obtention des informations de progression actuelles",
  "门店名称": "Nom du magasin",
  "请输入门店名称": "Veuillez entrer le nom du magasin",
  "登录密码": "Mot de passe de connexion",
  "请输入登录密码": "Veuillez entrer le mot de passe de connexion",
  "确认密码": "Confirmer le mot de passe",
  "请输入确认密码": "Veuillez entrer le mot de passe de confirmation",
  "联系人": "Contact",
  "请输入联系人": "Veuillez entrer le nom de contact",
  "联系电话": "Téléphone de contact",
  "请输入联系电话": "Veuillez entrer le numéro de téléphone de contact",
  "店铺类型": "Type de magasin",
  "分店": "Branche",
  "直营": "Vente directe",
  "商品分类": "Classification des marchandises",
  "同步主店": "Synchroniser avec le magasin principal",
  "分店创建": "Création de la succursale",
  "温馨提示：选择后，请勿随意修改，以免造成门店商品数据错乱": "Conseil chaleureux : après avoir choisi, veuillez ne pas modifier aléatoirement pour éviter la confusion des données des marchandises du magasin",
  "绑定用户": "Lier l'utilisateur",
  "选择用户": "Sélectionner un utilisateur",
  "用户昵称": "Pseudo de l'utilisateur",
  "门店logo": "Logo du magasin",
  "选择图片": "Sélectionner une image",
  "地址": "Adresse",
  "请输入地址": "Veuillez entrer une adresse",
  "门店坐标": "Coordonnées du magasin",
  "商家介绍": "Présentation du commerçant",
  "状态": "état",
  "开启": "Ouvert",
  "禁止": "Fermé",
  "营业状态": "état d'ouverture",
  "营业中": "Ouvert",
  "停止营业": "Fermé",
  "上传图片": "Télécharger une image",
  "获取当前门店失败，请刷新界面重试": "Échec de l'obtention du magasin actuel, veuillez rafraîchir la page et réessayer",
  "商城设置": "Paramètres du centre commercial",
  "商城名称": "Nom du centre commercial",
  "商城名称不能为空": "Le nom du centre commercial ne peut pas être vide",
  "访问网址后缀": "Suffixe de l'URL d'accès",
  "访问网址": "URL de visite",
  "手机网站": "Site web mobile",
  "默认": "Par défaut",
  "自定义": "Personnaliser",
  "Pad点餐网站": "Site de Commande par Tablette",
  "收银台网站": "Site de Caisse",
  "后厨网站": "Site de Cuisine",
  "会员设置": "Paramètres des Membres",
  "请选择默认头像": "Veuillez Sélectionner l'Avatar par Défaut",
  "门店二维码": "Code QR du Magasin",
  "下载": "Télécharger",
  "营业时间": "Heures d'Ouverture",
  "店内营业时间": "Heures d'Ouverture en Magasin",
  "请选择店内营业时间": "Veuillez Sélectionner les Heures d'Ouverture en Magasin",
  "开始时间": "Heure de Début",
  "结束时间": "Heure de Fin",
  "至": "à",
  "选择时间范围": "Sélectionner la Plage Horaire",
  "自提营业时间": "Heures d'Ouverture pour les Retraits",
  "请选择自提营业时间": "Veuillez Sélectionner les Heures d'Ouverture pour les Retraits",
  "外卖营业时间": "Heures d'Ouverture pour les Livraisons",
  "请选择外卖营业时间": "Veuillez Sélectionner les Heures d'Ouverture pour les Livraisons",
  "外卖配送": "Livraison à Emporter",
  "注": "Note",
  "外卖配送方式至少选择一个": "Au moins une méthode de livraison à emporter doit être sélectionnée",
  "店内配置": "Configuration en Magasin",
  "店内用餐方式至少选择一个": "Au moins une méthode de dînerd en magasin doit être sélectionnée",
  "堂食服务": "Service de Restauration sur Place",
  "店内堂食结算模式": "Mode de Règlement pour les Repas en Magasin",
  "先结账后用餐": "Payer d'Abord, Puis Dîner",
  "先用餐后结账": "Dîner d'Abord, Puis Payer",
  "收银台桌台清台设置": "Paramètres de Nettoyage des Tables de la Caisse",
  "定时清台": "Nettoyage de Table Programmé",
  "立即清台": "Nettoyage de Table Immédiat",
  "开启定时清台后，系统将在设置的时间后自动清除收银台点餐的桌台，此功能仅在餐前付款模式下生效": "En activant le nettoyage de table programmé, le système effacera automatiquement la table des commandes de la caisse après le temps défini. Cette fonction ne fonctionne qu'en mode de paiement avant le repas",
  "桌台订单清台设置": "Paramètres de Nettoyage des Commandes de table",
  "分钟后自动清理桌台（扫桌码点餐和收银桌台点餐定时清台时间）": "Nettoyer automatiquement la table quelques minutes plus tard (horaire de nettoyage des tables par scan du code table et timing des commandes de la caisse)",
  "店内堂食服务费": "Frais de Service de Restauration sur Place",
  "按就餐人数收取": "Facturé en Fonction du Nombre de Convives",
  "按每桌台收取": "Facturé par Table",
  "请输入服务费": "Veuillez Entrer les Frais de Service",
  "位": "Siège",
  "桌": "Table",
  "店内包装费类型": "Type de Frais d'Emballage en Magasin",
  "按商品收费": "Frais en Fonction des Produits",
  "按单收费": "Frais par Commande",
  "包装费": "Frais d'Emballage",
  "请输入包装费": "Veuillez Entrer les Frais d'Emballage",
  "外卖服务": "Service de Livraison à Emporter",
  "外卖包装费类型": "Type de Frais d'Emballage pour la Livraison à Emporter",
  "外卖配送范围": "Plage de Livraison pour la Livraison à Emporter",
  "请输入外卖配送范围": "Veuillez Entrer la Plage de Livraison pour la Livraison à Emporter",
  "外卖配送费": "Frais de Livraison pour la Livraison à Emporter",
  "请输入外卖配送费": "Veuillez Entrer les Frais de Livraison pour la Livraison à Emporter",
  "最低消费": "Consommation Minimum",
  "请输入最低消费": "Veuillez Entrer la Consommation Minimum",
  "添加类型": "Ajouter un Type",
  "排序": "Tri",
  "类型名称": "Nom du Type",
  "添加时间": "Ajouter l'Heure",
  "操作": "Opération",
  "删除": "Supprimer",
  "桌位管理": "Gestion des Tables",
  "最少人数": "Nombre Minimum de Personnes",
  "最多人数": "Nombre Maximum de Personnes",
  "取 消": "Annuler",
  "确 定": "Confirmer",
  "请输入类型名称": "Veuillez Entrer le Nom du Type",
  "排序不能为空": "Le Tri ne peut pas être Vide",
  "排序必须为数字": "Le Tri Doit être un Nombre",
  "添加成功": "Ajout Réussi",
  "修改类型": "Modifier le Type",
  "修改成功": "Modification Réussie",
  "添加区域": "Ajouter une Zone",
  "区域名称": "Nom de la Zone",
  "修改区域": "Modifier la Zone",
  "请输入区域名称": "Veuillez Entrer le Nom de la Zone",
  "分类名称": "Nom de la Catégorie",
  "编号": "Numéro",
  "选择区域": "Sélectionner une Zone",
  "请选择": "Veuillez Sélectionner",
  "选择类型": "Sélectionner le Type",
  "查询": "Rechercher",
  "桌号id": "ID de la Table",
  "所属区域": "Zone d'Appartenance",
  "桌位类型": "Type de Table",
  "桌位编码": "Code de la Table",
  "人数区间": "Plage de Nombre de Personnes",
  "人": "Personnes",
  "二维码": "Code QR",
  "桌位编号": "Numéro de Table",
  "请输入桌位编号": "Veuillez Entrer le Numéro de Table",
  "请选择类型名称": "Veuillez Sélectionner le Nom du Type",
  "请选择所属区域": "Veuillez Sélectionner la Zone d'Appartenance",
  "添加桌位": "Ajouter une Table",
  "关键词": "Mot-clé",
  "添加收银员": "Ajouter un Caissier",
  "姓名": "Nom",
  "登录账号": "Compte de Connexion",
  "联系方式": "Mode de Contact",
  "收银员管理": "Gestion des Caissiers",
  "编辑": "Modifier",
  "手机号": "Numéro de Téléphone Portable",
  "请输入登录账号": "Veuillez Entrer le Compte de Connexion",
  "长度在6到16个字符": "Longueur entre 6 et 16 caractères",
  "两次输入密码不一致！": "Les deux mots de passe saisis ne correspondent pas !",
  "禁用": "Désactiver",
  "删除后不可恢复，确认删除该记录吗?": "Impossible de récupérer après suppression, confirmer la suppression de cet enregistrement ?",
  "提示": "Conseil",
  "后厨人员管理": "Gestion du Personnel de Cuisine",
  "添加后厨人员": "Ajouter du Personnel de Cuisine",
  "添加后厨账号": "Ajouter un Compte de Cuisine",
  "普通分类": "Classification Générale",
  "添加分类": "Ajouter une Catégorie",
  "图片": "Image",
  "分类排序": "Tri de la Catégorie",
  "税率设置": "Réglage des Taxes",
  "添加税率": "Ajouter une Taxe",
  "税率分类名称": "Nom de Catégorie de Taxe",
  "税率": "Taux de Taxe",
  "适用于菜品分类": "Applicable à la Classification des Plats",
  "未找到相应数据": "Aucune Donnée Correspondante Trouvée",
  "请输入分类名称": "Veuillez Entrer le Nom de la Catégorie",
  "分类排序不能为空": "Le Tri de la Catégorie Ne Peut Pas être Vide",
  "分类排序必须为数字": "Le Tri de la Catégorie Doit être un Nombre",
  "正在翻译，请稍后": "Traduction en cours, veuillez patienter",
  "多语言翻译": "Traduction Multilingue",
  "修改分类": "Modifier la Catégorie",
  "翻译": "Traduction",
  "分类图片": "Image de Catégorie",
  "外卖商品": "Produits à Emporter",
  "店内商品": "Produits en Magasin",
  "商品管理": "Gestion des Produits",
  "分类管理": "Gestion des Catégories",
  "上架中": "En Vente",
  "下架": "Hors Vente",
  "商品名称": "Nom du Produit",
  "请输入商品名称": "Veuillez Entrer le Nom du Produit",
  "添加产品": "Ajouter un Produit",
  "全部": "Tout",
  "产品": "Produit",
  "实际销量": "Ventes Réelles",
  "库存": "Stock",
  "发布时间": "Heure de Publication",
  "销售价": "Prix de Vente",
  "下架中": "Hors Vente",
  "强制下架": "Forcer la Mise Hors Vente",
  "重新上架": "Remise en rayon",
  "上架": "En rayon",
  "确认要": "Confirmer pour",
  "成功": "Succès",
  "删除成功": "Suppression Effectuée avec Succès",
  "请先选择一个选项": "Veuillez d'abord sélectionner une option",
  "正在完成翻译，请稍后操作": "Traduction en cours, veuillez patienter pour continuer",
  "请检查表单的必填项是否全部填写": "Veuillez vérifier si tous les champs obligatoires du formulaire sont complétés",
  "补全成功": "Complétion Réussie",
  "主语言选择": "Sélection de la Langue Principale",
  "请选择主语言": "Veuillez Sélectionner la Langue Principale",
  "高级设置": "Paramètres Avancés",
  "取消": "Annuler",
  "修改": "Modifier",
  "保存成功": "Enregistrement Effectué avec Succès",
  "规格": "Spécification",
  "库存计算方式": "Méthode de Calcul des Stocks",
  "下单减库存": "Réduire les Stocks lors de la Commande",
  "特色分类": "Classification Caractéristique",
  "产品规格": "Spécifications du Produit",
  "单规格": "Unique Spécification",
  "多规格": "Multiples Spécifications",
  "此商品正在参加活动，不能修改规格": "Ce produit participe à une promotion et ne peut pas être modifié en termes de spécifications",
  "基本信息": "Informations de Base",
  "AI魔法创建": "Création Magique par IA",
  "通过人工智能技术，可以根据商品名称自动填写商品详细信息，如配料、卖点、口味等。": "Grace à la technologie de l'intelligence artificielle, les détails du produit tels que les ingrédients, les points de vente et les saveurs peuvent être automatiquement remplis en fonction du nom du produit.",
  "所属分类": "Catégorie d'Appartenance",
  "请选择商品分类": "Veuillez Sélectionner la Catégorie du Produit",
  "请填写商品详情": "Veuillez Renseigner les Détails du Produit",
  "商品详情": "Détails du Produit",
  "换一换": "échanger",
  "产品价格": "Prix du Produit",
  "请填写产品价格": "Veuillez Renseigner le Prix du Produit",
  "请填写包装费": "Veuillez Renseigner les Frais d'Emballage",
  "规格明细": "Détails de la Spécification",
  "规格名称": "Nom de la Spécification",
  "请输入内容": "Veuillez Entrer du Contenu",
  "价格": "Prix",
  "添加规格": "Ajouter une Spécification",
  "商品图片": "Image du Produit",
  "请上传商品图片": "Veuillez Télécharger l'Image du Produit",
  "从AI图库中选择": "Choisir à partir de la Bibliothèque d'Images par IA",
  "使用中文从AI图库搜索": "Rechercher à partir de la Bibliothèque d'Images par IA en Chinois",
  "AI图库": "Bibliothèque d'Images par IA",
  "确认使用": "Confirmer l'Utilisation",
  "AI未识别到您的商品图片": "L'IA n'a pas reconnu votre image de produit",
  "可在搜索框": "Disponible dans la Barre de Recherche",
  "更换菜品名称": "Changer le Nom du Plat",
  "请输入菜品名称！": "Veuillez Entrer le Nom du Plat !",
  "请在主语言界面上进行操作": "Veuillez Opérer sur l'Interface de Langue Principale",
  "本商品正在参加活动，不能删除规格！": "Ce produit participe à une activité, les spécifications ne peuvent pas être supprimées !",
  "不能再删除了": "Impossible de Supprimer Davantage",
  "多语言": "Multilingue",
  "商品加料": "Accompagnements du Produit",
  "添加加料": "Ajouter des Accompagnements",
  "加料名称": "Nom de l'Accompagnement",
  "如:杯型": "Par Exemple : Type de Verre",
  "内容": "Contenu",
  "积分设置": "Paramètres de Points",
  "是否开启积分赠送": "Activer l'Offre de Points",
  "关闭": "Fermer",
  "其他设置": "Autres Paramètres",
  "商品状态": "état du Produit",
  "选择商品状态": "Choisir l'état du Produit",
  "初始销量": "Ventes Initiales",
  "商品排序": "Tri des Produits",
  "限购数量": "Quantité d'Achat Limitée",
  "每个会员购买的最大数量，0为不限购": "La quantité maximale que chaque membre peut acheter, 0 pour illimité",
  "会员折扣设置": "Paramètres de Réduction Membre",
  "是否开启会员折扣": "Activer la Réduction Membre",
  "默认折扣": "Réduction par Défaut",
  "单独设置折扣": "Définir la Réduction Séparément",
  "默认折扣：默认为用户所属会员等级的折扣率": "Réduction par Défaut : le taux de réduction est celui du niveau de membre auquel l'utilisateur appartient",
  "折扣佣金类型": "Type de Commission sur les Réductions",
  "百分比": "Pourcentage",
  "固定金额": "Montant Fixe",
  "会员等级": "Niveau de Membre",
  "折扣": "Réduction",
  "请输入折扣": "Veuillez Entrer la Réduction",
  "分销设置": "Paramètres de Distribution",
  "是否开启分销": "Activer la Distribution",
  "分销规则": "Règles de Distribution",
  "平台规则": "Règles de la Plateforme",
  "单独规则": "Règles Individuelles",
  "平台规则：层级": "Règles de la Plateforme : Niveau",
  "1级佣金": "Commission de Niveau 1",
  "2级佣金": "Commission de Niveau 2",
  "3级佣金": "Commission de Niveau 3",
  "分销佣金类型": "Type de Commission de Distribution",
  "单独分销设置": "Paramètres de Distribution Individuels",
  "一级佣金": "Commission de Niveau 1",
  "二级佣金": "Commission de Niveau 2",
  "三级佣金": "Commission de Niveau 3",
  "请填写商品名称": "Veuillez Renseigner le Nom du Produit",
  "你选择商品分类": "Vous Choisissez la Catégorie du Produit",
  "商品卖点": "Point de Vente du Produit",
  "配料": "Ingrédients",
  "添加项": "Ajouter un élément",
  "删除项": "Supprimer un élément",
  "审核状态": "état de Vérification",
  "选择审核状态": "Choisir l'état de Vérification",
  "通过": "Approuvé",
  "未通过": "Non Approuvé",
  "审核备注": "Remarque de Vérification",
  "请输入拒绝原因": "Veuillez Entrer la Raison du Refus",
  "商品属性": "Attributs du Produit",
  "添加属性": "Ajouter des Attributs",
  "属性名称": "Nom de l'Attribut",
  "属性值": "Valeur de l'Attribut",
  "至少填写两个": "Veuillez au moins en remplir deux",
  "如:温度": "Par Exemple : Température",
  "口味": "Saveur",
  "商品同步": "Synchronisation des Produits",
  "同步至外卖": "Synchroniser vers la Vente à Emporter",
  "是": "Oui",
  "否": "Non",
  "库存数量": "Quantité en Stock",
  "请填写库存数量": "Veuillez Renseigner la Quantité en Stock",
  "请上传分类图片": "Veuillez Télécharger l'Image de Catégorie",
  "发布": "Publier",
  "级": "Niveau",
  "请填写口味": "Veuillez Renseigner la Saveur",
  "从AI图库搜索": "Rechercher dans la Bibliothèque d'Images par IA",
  "AI获取标签": "L'IA Obtient des étiquettes",
  "标签": "étiquette",
  "添加的标签可以帮助AI点餐助手更准确地理解顾客的点餐需求": "Les étiquettes ajoutées peuvent aider l'assistant de commande IA à comprendre plus précisément les besoins de commande des clients",
  "同步至店内": "Synchroniser en Magasin",
  "是否同步商品至外卖": "Synchroniser les Produits vers la Vente à Emporter",
  "是否同步商品至店内": "Synchroniser les Produits en Magasin",
  "付款减库存": "Réduction des Stocks lors du Paiement",
  "菜品录入使用语言": "Langue Utilisée pour la Saisie des Plats",
  "网站主页": "Page d'Accueil du Site Web",
  "主题编辑": "édition du Thème",
  "我的菜单": "Mon Menu",
  "添加菜单": "Ajouter un Menu",
  "菜单名称": "Nom du Menu",
  "图标": "Icône",
  "是否显示": "Afficher",
  "更新时间": "Heure de Mise à Jour",
  "正在处理": "Traitement en Cours",
  "处理失败，请重试": "échec du Traitement, Veuillez Réessayer",
  "此操作将永久删除该记录, 是否继续?": "Cette action supprimera définitivement cet enregistrement, voulez-vous continuer?",
  "确定": "Confirmer",
  "主题选择": "Sélection du Thème",
  "主题一": "Thème Un",
  "主题二": "Thème Deux",
  "主题三": "Thème Trois",
  "主题四": "Thème Quatre",
  "主题五": "Thème Cinq",
  "主题六": "Thème Six",
  "主页预览": "Aperçu de la Page d'Accueil",
  "撤回": "Retirer",
  "获取预览网站失败,请检查网络或联系管理员": "échec de la Prévisualisation du Site, Veuillez Vérifier la Connexion ou Contacter l'Administrateur",
  "撤回成功": "Retrait Réussi",
  "编辑菜单": "éditer le Menu",
  "请输入广告标题": "Veuillez Entrer le Titre de l'Annonce",
  "图标大小为": "La Taille de  l'icône est de",
  "显示": "Afficher",
  "隐藏": "Cacher",
  "请输入数字": "Veuillez Entrer un Nombre",
  "链接": "Lien",
  "选择链接": "Choisir un Lien",
  "提交": "Soumettre",
  "请输入菜单名称": "Veuillez Entrer le Nom du Menu",
  "请选择链接地址": "Veuillez Sélectionner l'Adresse du Lien",
  "链接到": "Lien vers",
  "请上传图标": "Veuillez Télécharger  l'icône",
  "确定要删除吗?": "Êtes-vous sûr de votre intention de supprimer?",
  "次浏览": "Nombre de Vues",
  "每日必拼": "Incontournable Quotidien",
  "更多": "Plus",
  "2人团": "Groupe de 2 Personnes",
  "去开团": "Démarrer un Groupe",
  "活动砍价": "Négociation d'Activité",
  "已抢2件": "Déjà Acheté 2 Articles",
  "立即砍价": "Négocier Maintenant",
  "满": "Complet",
  "可用": "Disponible",
  "立即领取": "Obtenir Immédiatement",
  "热门直播": "Diffusion en Direct Populaire",
  "已售": "Vendu",
  "限时秒杀": "Vente Flash Limitée dans le Temps",
  "搜索商品": "Rechercher des Produits",
  "线下门店": "Magasin Hors Ligne",
  "门店地址": "Adresse du Magasin",
  "您的浏览器不支持 video 标签": "Votre Navigateur ne Prend pas en Charge les Balises Vidéo",
  "店家正在直播、折扣套餐秒杀中": "Le Propriétaire du Magasin est en Train de Diffuser en Direct, Forfaits de Réduction en Cours",
  "进入": "Entrer",
  "至少保留一个": "Garder au Moins un",
  "咨询分类": "Catégorie de Consultation",
  "全部分类": "Toutes les Catégories",
  "显示数量": "Afficher la Quantité",
  "咨询数据请到": "Pour les Données de Consultation, Veuillez Aller à",
  "中管理": "Gérer en",
  "插件": "Plugin",
  "资讯": "Information",
  "显示类型": "Type d'Affichage",
  "有图模式": "Mode avec Image",
  "无图模式": "Mode sans Image",
  "组件样式": "Style de Composant",
  "显示内容": "Contenu d'Affichage",
  "拼团价格": "Prix de Regroupement",
  "划线价格": "Prix Barré",
  "指示点颜色": "Couleur du Point Indicateur",
  "重置": "Réinitialiser",
  "切换时间": "Temps de Changement",
  "轮播图自动切换的间隔时间，单位：毫秒": "Temps d'Intervalle de Changement Automatique pour Images du Carrousel, Unité : Milliseconde",
  "建议尺寸": "Taille Recommandée",
  "链接地址": "Adresse du Lien",
  "添加一个": "Ajouter Une",
  "标题内容": "Contenu du Titre",
  "文字内容": "Contenu Textuel",
  "链接名称": "Nom du Lien",
  "正在砍价": "Négociation en Cours",
  "商品原价": "Prix d'Origine des Marchandises",
  "背景颜色": "Couleur de Fond",
  "组件高度": "Hauteur du Composant",
  "上下边距": "Marge Haut et Bas",
  "线条样式": "Style de Ligne",
  "实线": "Ligne Pleine",
  "虚线": "Ligne Pointillée",
  "点状": "En Pointillés",
  "线条颜色": "Couleur de la Ligne",
  "线条高度": "Hauteur de la Ligne",
  "左右边距": "Marge Gauche et Droite",
  "标题": "Titre",
  "颜色": "Couleur",
  "每行数量": "Nombre Par Ligne",
  "1个": "1 Pièce",
  "2个": "2 Pièces",
  "文字颜色": "Couleur du Texte",
  "公告图标": "Icône d'Annonce",
  "公告内容": "Contenu de l'Annonce",
  "商品来源": "Source du Produit",
  "自动获取": "Acquisition Automatique",
  "手动选择": "Sélection Manuelle",
  "综合": "Complet",
  "商品列表": "Liste de Produits",
  "选择产品": "Choisir le Produit",
  "列表平铺": "Pavage de Liste",
  "横向滑动": "Défilement Horizontal",
  "分列数量": "Nombre de Colonnes",
  "单列": "Une Colonne",
  "两列": "Deux Colonnes",
  "三列": "Trois Colonnes",
  "商品价格": "Prix du Produit",
  "商品销量": "Ventes du Produit",
  "提示文字": "Texte d'Aide",
  "搜索框样式": "Style de la Boîte de Recherche",
  "方形": "Carré",
  "圆角": "Coins Arrondis",
  "圆弧": "Arc",
  "文字对齐": "Alignement du Texte",
  "居左": "Gauche",
  "居中": "Centre",
  "居右": "Droite",
  "秒杀价格": "Prix de Vente Flash",
  "底边距": "Marge Inférieure",
  "右边距": "Marge Droite",
  "不透明度": "Opacité",
  "客服类型": "Type de Service Client",
  "在线聊天": "Chat en Ligne",
  "拨打电话": "Appel Téléphonique",
  "电话号码": "Numéro de Téléphone",
  "客服图标": "Icône du Service Client",
  "标题类型": "Type de Titre",
  "页面名称": "Nom de la Page",
  "页面名称仅用于后台查找": "Le Nom de la Page Est Utilisé Uniquement pour la Recherche en Arrière-plan",
  "分享标题": "Titre de Partage",
  "小程序端转发时显示的标题": "Titre Affiché lors de la Transmission du Mini Programme",
  "文章分类": "Catégorie d'Article",
  "文章数据请到": "Veuillez Consulter les Données de l'Article à",
  "内容管理": "Gestion de Contenu",
  "文章列表": "Liste d'Articles",
  "单行": "Une Ligne",
  "两行": "Deux Lignes",
  "门店列表": "Liste de Magasins",
  "选择门店": "Choisir un Magasin",
  "展示数量": "Quantité d'Affichage",
  "视频高度": "Hauteur de la Vidéo",
  "滑块可用左右方向键精确调整": "Le Curseur Peut être Ajusté Précisément avec les Touches Gauche et Droite",
  "视频封面": "Image de Couverture de la Vidéo",
  "视频地址": "Adresse de la Vidéo",
  "自动播放": "Lecture Automatique",
  "布局方式": "Méthode de Mise en Page",
  "堆积两列": "Empiler Deux Colonnes",
  "堆积三列": "Empiler Trois Colonnes",
  "堆积四列": "Empiler Quatre Colonnes",
  "橱窗样式": "Style de Vitrine",
  "橱窗样式最多显示四张图片，超出隐藏": "Le Style de Vitrine Affiche Jusqu'à Quatre Images au Maximum, Masqué s'il y a Plus",
  "请确保所有图片的尺寸/比例相同": "Veuillez Veiller à ce que toutes les Images aient la Même Taille/Proportion",
  "标题文字": "Texte du Titre",
  "组件库": "Bibliothèque de Composants",
  "媒体组件": "Composant Média",
  "商城组件": "Composant de Centre Commercial",
  "工具组件": "Composant d'Outils",
  "登录组件": "Composant de Connexion",
  "资讯管理": "Gestion des Informations",
  "添加资讯": "Ajouter des Informations",
  "资讯ID": "ID de l'Information",
  "封面": "Couverture",
  "资讯标题": "Titre de l'Information",
  "虚拟阅读量": "Volume de Lecture Virtuel",
  "实际阅读量": "Volume de Lecture Réel",
  "资讯排序": "Tri des Informations",
  "已取消删除": "Suppression Annulée",
  "请输入文章标题": "Veuillez Entrer le Titre de l'Article",
  "描述": "Description",
  "请输入文章描述": "Veuillez Entrer la Description de l'Article",
  "缩略图": "Miniature",
  "资讯分类": "Catégorie d'Information",
  "资讯状态": "état de l'Information",
  "资讯内容": "Contenu de l'Information",
  "分类ID": "ID de Catégorie",
  "编辑分类": "éditer la Catégorie",
  "恭喜你，修改成功": "Félicitations, Modification Réussie",
  "编辑资讯": "éditer l'Information",
  "份": "Portion",
  "中文": "Chinois",
  "英语": "Anglais",
  "意大利语": "Italien",
  "德语": "Allemand",
  "西班牙语": "Espagnol",
  "法语": "Français",
  "克罗地亚": "Croate",
  "斯洛文尼亚": "Slovène",
  "匈牙利语": "Hongrois",
  "规格库": "Bibliothèque de Spécifications",
  "属性库": "Bibliothèque d'Attributs",
  "加料库": "Bibliothèque d'Ingrédients",
  "规格名": "Nom de la Spécification",
  "批量删除": "Suppression en Lots",
  "请输入规格名称": "Veuillez Entrer le Nom de la Spécification",
  "删除后不可恢复，确认删除吗?": "Impossible à récupérer après suppression, confirmer la suppression?",
  "属性名": "Nom de l'Attribut",
  "请输入属性名称": "Veuillez Entrer le Nom de l'Attribut",
  "请输入属性值": "Veuillez Entrer la Valeur de l'Attribut",
  "添加属性名": "Ajouter un Nom d'Attribut",
  // =========== 建店必做 end ==================

  // ================ 订单 start ================
  "实时概况": "Vue en temps réel",
  "营业总额": "Chiffre d'affaires total",
  "有效订单": "Commandes valides",
  "退款金额": "Montant du remboursement",
  "销量排行榜": "Classement des ventes",
  "销售额排行榜": "Classement du chiffre d'affaires",
  "订单号": "Numéro de commande",
  "请输入订单号": "Veuillez saisir le numéro de commande",
  "配送方式": "Mode de livraison",
  "起始时间": "Heure de début",
  "开始日期": "Date de début",
  "结束日期": "Date de fin",
  "导出": "Exporter",
  "全部订单": "Toutes les commandes",
  "未付款": "Impayé",
  "进行中": "En cours",
  "已完成": "Terminé",
  "订单信息": "Informations sur la commande",
  "下单时间": "Heure de la commande",
  "取消申请中": "Demande d'annulation en cours",
  "实付款": "Paiement réel",
  "含服务费": "Frais de service inclus",
  "含包装费": "Frais d'emballage inclus",
  "买家": "Acheteur",
  "出餐状态": "état de la commande",
  "准备中": "En préparation",
  "出餐中": "En cours de préparation",
  "待取餐": "En attente de retrait",
  "交易状态": "état de la transaction",
  "支付方式": "Moyen de paiement",
  "订单详情": "Détails de la commande",
  "出餐": "Servir le repas",
  "退款": "Remboursement",
  "核销": "Vérifier",
  "确定要出餐吗?": "Êtes-vous sûr de votre intention de fournir le repas?",
  "确定要核销吗?": "Êtes-vous certain de votre intention de vérifier?",
  "恭喜你，操作成功": "Félicitations, opération réussie",
  "已取消核销": "Vérification annulée",
  "订单来源": "Source de la commande",
  "订单金额": "Montant de la commande",
  "配送费": "Frais de livraison",
  "服务费": "Frais de service",
  "优惠券抵扣": "Déduction du coupon",
  "积分抵扣": "Déduction de points",
  "满减金额": "Montant de réduction",
  "优惠金额": "Montant de la réduction",
  "实付款金额": "Montant réel payé",
  "用餐方式": "Méthode de repas",
  "取餐时间": "Heure de retrait",
  "桌号": "Numéro de table",
  "修改价格": "Modifier le prix",
  "门店信息": "Informations sur le magasin",
  "商品信息": "Informations sur les produits",
  "会员折扣价": "Prix de réduction exclusifs pour les membres",
  "购买数量": "Quantité d'achat",
  "商品总价": "Prix total des produits",
  "收货信息": "Informations de réception",
  "收货人": "Destinataire",
  "收货电话": "Téléphone du destinataire",
  "收货地址": "Adresse de livraison",
  "备注": "Remarque",
  "自提用户信息": "Informations sur les utilisateurs de retrait en magasin",
  "用户信息": "Informations sur l'utilisateur",
  "联系手机": "Contact Mobile",
  "付款信息": "Informations de paiement",
  "应付款金额": "Montant à payer",
  "支付流水号": "Numéro de transaction de paiement",
  "付款状态": "état du paiement",
  "付款时间": "Heure du paiement",
  "发货信息": "Informations d'expédition",
  "发货状态": "état d'expédition",
  "取消信息": "Informations d'annulation",
  "商家备注": "Remarque du vendeur",
  "门店自提核销": "Confirmation d'enlèvement en magasin",
  "核销员": "Employé de vérification",
  "核销状态": "état de la vérification",
  "已核销": "Vérifié",
  "核销时间": "Heure de vérification",
  "返回上一页": "Retour à la page précédente",
  "确认发货": "Confirmer la livraison",
  "确认审核": "Confirmer l'approbation",
  "请选择物流公司": "Veuillez sélectionner une entreprise de logistique",
  "请填写物流单号": "Veuillez saisir le numéro de suivi logistique",
  "恭喜你，发货成功": "Félicitations, livraison réussie",
  "恭喜你，审核成功": "Félicitations, approbation réussie",
  "订单价格修改": "Modification du prix de la commande",
  "运费金额": "Montant des frais d'expédition",
  "最终付款价": "Prix final à payer",
  "取消订单": "Annuler la commande",
  "请输入备注": "Veuillez saisir une remarque",
  "请输入退款金额": "Veuillez saisir le montant du remboursement",
  "确认退款?": "Confirmer le remboursement?",
  "已取消退款": "Remboursement annulé",
  "含配送费": "Frais de livraison inclus",
  "确认送达": "Confirmer la livraison",
  "是否确认此操作?": "Confirmez-vous cette opération?",
  "配送状态": "état de la livraison",
  "备注信息": "Informations de remarque",
  "期望配送时间": "Heure de livraison prévue",
  "订单状态": "état de la commande",
  "骑手姓名": "Nom du coursier",
  "骑手电话": "Téléphone du coursier",
  "操作时间": "Heure de l'opération",
  "详情": "Détails",
  "此操作将确认送达, 是否继续?": "Cette opération confirmera la livraison, souhaitez-vous continuer?",
  "配送时间": "Heure de livraison",
  "配送信息": "Informations de livraison",
  "配送类型": "Type de livraison",
  "配送距离": "Distance de livraison",
  "配送电话": "Téléphone de livraison",
  "配送费用": "Frais de livraison",
  "送达时间": "Heure d'arrivée",
  "取消原因": "Raison de l'annulation",
  "请输入取消原因": "Veuillez saisir la raison de l'annulation",
  "米": "Mètre",
  "门店ID": "Identifiant du magasin",
  "联系地址": "Adresse de contact",
  "下载二维码": "Télécharger le code QR",
  "下载类型": "Catégorie de téléchargement",
  "H5网页": "Page Web H5",
  "添加门店": "Ajouter un établissement",
  "设置": "Configuration",
  "恭喜你，门店删除成功": "Félicitations, suppression du magasin réussie",
  "请输入地点": "Veuillez saisir l'emplacement",
  "添加": "Ajouter",
  "等级": "Niveau",
  "请选择会员等级": "Veuillez sélectionner le niveau d'adhésion",
  "性别": "Genre",
  "请选择性别": "Veuillez sélectionner le genre",
  "微信昵称": "Pseudo WeChat",
  "请输入微信昵称": "Veuillez saisir votre pseudo WeChat",
  "微信头像": "Image de profil WeChat",
  "昵称": "Surnom",
  "用户余额": "Solde utilisateur",
  "累积消费金额": "Montant total des achats",
  "注册时间": "Date d'inscription",
  "分钟后自动清理桌台": "Nettoyage automatique des tables après minutes",
  "扫桌码点餐和收银桌台点餐定时清台时间": "Heure de nettoyage planifiée des tables pour la commande par balayage de table et les tables de caisse",
  "到店自提": "à récupérer en magasin",
  "打包带走": "à emporter",
  "店内就餐": "Repas sur place",
  "外卖配送至少选择一种！": "Sélectionnez au moins une méthode de livraison pour la vente à emporter!",
  "店内配置至少选择一种！": "Sélectionnez au moins une configuration en magasin!",
  "恭喜你，设置成功": "Félicitations, configuration réussie",
  "恭喜你，门店修改成功": "Félicitations, modification du magasin réussie",
  "门店": "Magasin",
  "提现金额": "Montant de retrait",
  "打款方式": "Mode de paiement",
  "待审核": "En attente de révision",
  "审核通过": "Approuvé",
  "驳回": "Rejeté",
  "原因": "Raison",
  "已打款": "Paiement effectué",
  "审核": "Révision",
  "确认打款": "Confirmer le paiement",
  "确认要打款吗?": "Confirmer le paiement?",
  "供应商名称": "Nom du fournisseur",
  "余额变动场景": "Scénario de changement de solde",
  "收入": "Revenu",
  "提现": "Retrait",
  "起始日期": "Date de départ",
  "变动金额": "Montant changé",
  "描述/说明": "Description/Explication",
  "创建时间": "Heure de création",
  "恭喜你，门店添加成功": "Félicitations, ajout de magasin réussi",
  "驳回原因": "Raison du rejet",
  "提现审核": "Révision des retraits",
  "小票打印设置": "Paramètres d'impression des reçus",
  "是否开启商户小票打印": "Activer l'impression des reçus pour les commerçants",
  "选择打印机": "Sélectionner l'imprimante",
  "是否开启顾客小票打印": "Activer l'impression des reçus pour les clients",
  "选择打印机二": "Sélectionner l'imprimante deux",
  "是否开启厨房小票打印": "Activer l'impression des reçus pour la cuisine",
  "选择打印机三": "Sélectionner l'imprimante trois",
  "恭喜你，打印设置成功": "Félicitations, réglage d'impression réussi",
  "小票打印机列表": "Liste des imprimantes de reçus",
  "打印机ID": "Identifiant de l'imprimante",
  "打印机名称": "Nom de l'imprimante",
  "编辑小票打印机": "Modifier l'imprimante de reçus",
  "打印机类型": "Type d'imprimante",
  "米泰打印机": "Imprimante Mettai",
  "打印机编号": "Numéro de série de l'imprimante",
  "打印机编号为9位数字，查看米泰打印机底部贴纸上面的编号": "Le numéro de série de l'imprimante est composé de 9 chiffres. Veuillez consulter le numéro sur l'autocollant situé au-dessus de la base de l'imprimante Mettai",
  "打印机秘钥": "Clé de l'imprimante",
  "打印联数": "Copies d'impression",
  "同一订单，打印的次数": "Nombre d'impressions pour la même commande",
  "数字越小越靠前": "Un nombre plus petit signifie une priorité plus élevée",
  "新增小票打印机": "Ajouter une nouvelle imprimante de reçu",
  "恭喜你，添加成功": "Félicitations, ajout réussi",
  "配送方式设置": "Réglage du mode de livraison",
  "商家配送": "Livraison par le commerçant",
  "自动配送时间(分钟)": "Temps de livraison automatique (minutes)",
  "设置0不自动配送，下单后未配送，设置时间后自动操作配送": "Mettre à 0 signifie pas de livraison automatique. Après la commande sans livraison, la livraison automatique sera initiée après le temps défini",
  "商户编号": "Identifiant du commerçant",
  "门店编号": "Identifiant du magasin",
  "环境": "Environnement",
  "测试环境": "Environnement de test",
  "正式环境": "Environnement de production",
  "回调地址": "Adresse de rappel",
  "运营城市": "Ville opérationnelle",
  "恭喜你，上传设置成功": "Félicitations, paramètres de téléchargement réussis",
  "菜品打印列表": "Liste d'impression des plats",
  "名称": "Nom",
  "打印类型": "Type d'impression",
  "外卖": "à emporter",
  "店内": "Sur place",
  "菜品打印": "Impression des plats",
  "是否开启": "Activer",
  "配送打印": "Imprimer la livraison",
  "店内打印": "Impression en interne",
  "打印方式": "Méthode d'impression",
  "付款打印": "Impression des paiements",
  "下单打印": "Impression de la commande",
  "商品分组": "Regroupement des produits",
  "男": "Homme",
  "女": "Femme",
  "未知": "Inconnu",
  "文件管理": "Gestion de fichiers",
  "移动至": "Déplacer vers",
  "点击上传": "Cliquez pour télécharger",
  "删除失败": "échec de la suppression",
  "请选择文件": "Veuillez sélectionner un fichier",
  "确定移动选中的文件吗？, 是否继续?": "Êtes-vous sûr de vouloir déplacer les fichiers sélectionnés? Souhaitez-vous continuer?",
  "只能上传图片！": "Seules les images peuvent être téléchargées!",
  "上传文件只能是图片格式!": "Le fichier téléchargé doit être au format image!",
  "上传文件大小不能超过 2MB!": "La taille du fichier téléchargé ne peut pas dépasser 2 Mo!",
  "请查看/裁切其它上传图片!": "Veuillez consulter/couper d'autres images téléchargées!",
  "图片上传中,请等待": "Téléchargement de l'image en cours, veuillez patienter",
  "当前图片上传失败!": "échec du téléchargement de l'image actuelle!",
  "本次上传图片失败": "échec du téléchargement de l'image cette fois-ci",
  "本次最多只能上传1个文件": "Seul 1 fichier peut être téléchargé à la fois",
  "裁剪图片": "Recadrer l'image",
  "选择优惠券": "Choisir un bon de réduction",
  "数量": "Quantité",
  "无限制": "Illimité",
  "请输入等级名称": "Veuillez saisir le nom du niveau",
  "长度在3到5个字符": "Longueur doit être entre 3 et 5 caractères",
  "错了哦，这是一条错误消息": "Oops, ceci est un message d'erreur",
  "增加税率": "Ajouter un taux d'imposition",
  "税率分类": "Catégorie de taux d'imposition",
  "请输入税率分类": "Veuillez saisir la catégorie de taux d'imposition",
  "自定义税率分类": "Catégorie de taux d'imposition personnalisée",
  "请输入税率值": "Veuillez saisir la valeur du taux d'imposition",
  "单位是": "L'unité est",
  "适用菜品分类": "Catégorie de plat applicable",
  "请选择菜品分类": "Veuillez sélectionner une catégorie de plat",
  "修改税率信息": "Modifier les informations sur le taux d'imposition",
  "分类名称不能为空": "Le nom de la catégorie ne peut pas être vide",
  // ================= 门店 end ==============
  // =====================  营销工具start ==========
  "会员管理": "Gestion des adhésions",
  "等级管理": "Gestion des niveaux",
  "余额明细": "Détails du solde",
  "请输入昵称": "Veuillez saisir un pseudo",
  "邮箱": "E-mail",
  "请输入邮箱地址": "Veuillez saisir une adresse e-mail",
  "无等级": "Aucun niveau",
  "余额": "Solde",
  "积分": "Points",
  "生日": "Anniversaire",
  "充值": "Recharger",
  "恭喜你，用户删除成功": "Félicitations, utilisateur supprimé",
  "请选择等级": "Veuillez sélectionner un niveau",
  "管理员备注": "Remarques de l'administrateur",
  "请输入管理员备注": "Veuillez saisir les remarques de l'administrateur",
  "恭喜你，用户修改成功": "Félicitations, utilisateur modifié avec succès",
  "会员充值": "Recharge d'adhérent",
  "充值余额": "Montant de recharge",
  "当前余额": "Solde actuel",
  "充值方式": "Méthode de recharge",
  "增加": "Augmenter",
  "减少": "Diminuer",
  "最终金额": "Montant final",
  "变更金额": "Montant modifié",
  "请输入变更金额": "Veuillez saisir le montant modifié",
  "添加等级": "Ajouter un niveau",
  "等级名称": "Nom du niveau",
  "权重": "Poids",
  "升级条件": "Conditions de mise à niveau",
  "等级权重": "Poids du niveau",
  "请输入等级权重": "Veuillez saisir le poids du niveau",
  "权重越大，等级越高": "Plus le poids est élevé, plus le niveau est élevé",
  "等级折扣": "Remise de niveau",
  "请输入等级折扣": "Veuillez saisir la remise de niveau",
  "满足以下勾选的其中一个条件，会员自动升级到该等级": "Satisfaire l'une des conditions cochées ci-dessous déclenchera automatiquement la mise à niveau du membre à ce niveau",
  "累计消费满": "Dépenses cumulées atteignent",
  "编辑等级": "Modifier le niveau",
  "累计积分满": "Points cumulés atteignent",
  "推荐人数满": "Nombre de recommandations atteint",
  "恭喜你，等级修改成功": "Félicitations, niveau modifié avec succès",
  "个": "pièces",
  "充值设置": "Paramètres de recharge",
  "是否开启余额充值": "Activer la recharge de solde",
  "注：如开启则移动端显示充值按钮，如果小程序没有资质审核不过可不开启": "Note : Si activé, le bouton de recharge sera affiché sur l'application mobile; s'il y a un échec de qualification pour la mini-application, cela peut rester désactivé",
  "是否开启自定义金额": "Activer le montant personnalisé",
  "注：如开启则用户可以填写充值金额": "Note : Si activé, les utilisateurs peuvent saisir un montant de recharge personnalisé",
  "最低充值金额": "Montant minimum de recharge",
  "注：自定义充值金额最低充值多少€": "Note : Quel est le montant minimum de recharge pour les montants personnalisés ?",
  "充值说明": "Instructions de recharge",
  "充值套餐": "Forfaits de recharge",
  "支付金额": "Montant payé",
  "到账数量": "Montant reçu",
  "充值时间": "Heure de la recharge",
  "到账金额": "Montant reçu",
  "赠送金额": "Montant offert",
  "提现设置": "Paramètres de retrait",
  "是否开启提现": "Activer les retraits",
  "注：如开启则移动端显示余额提现": "Note : Si activé, l'application mobile affichera l'option de retrait de solde",
  "提现比例": "Pourcentage de retrait",
  "注：提现比例请填写数字0~100": "Note : Veuillez saisir un pourcentage de retrait entre 0 et 100",
  "例：提现金额(100.00元) * 提现比例(100%) = 实际到账(100€)": "Exemple : Montant de retrait (100,00 $) * Pourcentage de retrait (100 %) = Montant reçu réellement (100 €)",
  "最低提现金额": "Montant minimum de retrait",
  "注：最低提现金额多少元": "Note : Quel est le montant minimum de retrait en yuans ?",
  "请选择状态": "Veuillez sélectionner l'état",
  "提现方式": "Méthode de retrait",
  "请选择提现方式": "Veuillez sélectionner une méthode de retrait",
  "微信": "WeChat",
  "支付宝": "Alipay",
  "银行卡": "Carte bancaire",
  "请输入用户ID": "Veuillez saisir l'identifiant de l'utilisateur",
  "请输入昵称/姓名/手机号": "Veuillez saisir le pseudo/nom/numéro de téléphone",
  "提现信息": "Informations de retrait",
  "支付宝名称": "Nom Alipay",
  "支付宝账号": "Compte Alipay",
  "银行名称": "Nom de la banque",
  "开户名": "Nom du titulaire",
  "银行卡号": "Numéro de carte bancaire",
  "申请时间": "Heure de la demande",
  "审核时间": "Heure de révision",
  "微信付款": "Paiement WeChat",
  "该操作 将使用微信支付企业付款到零钱功能，确定打款吗？": "Cette opération utilisera la fonction de paiement professionnel de WeChat pour effectuer le transfert vers le portefeuille. Êtes-vous sûr de vouloir continuer ?",
  "添加充值套餐": "Ajouter un forfait de recharge",
  "套餐名称": "Nom du forfait",
  "请输入套餐名称": "Veuillez saisir le nom du forfait",
  "请输入支付金额": "Veuillez saisir le montant du paiement",
  "请输入赠送金额": "Veuillez indiquer le montant offert",
  "请输入到账金额": "Veuillez spécifier le montant crédité",
  "请输入排序": "Veuillez saisir l'ordre de tri",
  "用户ID": "Identifiant de l'utilisateur",
  "会员卡管理": "Gestion des cartes d'adhésion",
  "领取记录": "Enregistrements de réception",
  "删除记录": "Supprimer l'enregistrement",
  "请输入关键词": "Veuillez saisir le mot-clé",
  "过期": "Expiré",
  "有效": "Valide",
  "客户信息": "Données clients",
  "会员卡名称": "Nom de la carte d'adhésion",
  "有效期": "Période de validité",
  "折": "Réduction",
  "领取时间": "Heure de réception",
  "延期": "Prolongation",
  "撤销": "Annuler",
  "添加会员卡": "Ajouter une carte d'adhésion",
  "启用": "Activer",
  "月": "Mois",
  "永久有效": "Valide en permanence",
  "领取数量": "Nombre de récepteurs",
  "发卡": "Délivrer la carte",
  "领取设置": "Paramètres de réception",
  "请检查必填项是否填写完整": "Veuillez vérifier si les champs obligatoires sont bien remplis",
  "领取人数": "Nombre de destinataires",
  "删除时间": "Heure de suppression",
  "请填写有效期": "Veuillez indiquer la période de validité",
  "有效期限（月），0为永久有效": "Période de validité (en mois), 0 pour une validité indéfinie",
  "请填写价格": "Veuillez indiquer le prix",
  "用户购买会员卡需要支付的金额，0为用户免费领取": "Le montant que les utilisateurs doivent payer pour acheter la carte d'adhésion, 0 pour une attribution gratuite",
  "使用须知": "Directives d'utilisation",
  "请填写使用须知": "Veuillez fournir des instructions d'utilisation",
  "请填写会员卡名称": "Veuillez indiquer le nom de la carte d'adhésion",
  "卡片类型": "Type de carte",
  "卡片样式": "Style de carte",
  "请填写排序": "Veuillez indiquer l'ordre de tri",
  "会员权益": "Avantages de l'adhésion",
  "无折扣": "Aucune réduction",
  "请填写折扣": "Veuillez indiquer la réduction",
  "开卡赠送": "Cadeau à l'activation de la carte",
  "优惠券": "Coupon",
  "请填写积分数量": "Veuillez indiquer la quantité de points",
  "请填写余额数量": "Veuillez indiquer le montant du solde",
  "请填写优惠券": "Veuillez indiquer le coupon",
  "添加优惠券": "Ajouter un coupon",
  "券名称": "Nom du coupon",
  "每人领取数量": "Quantité par personne",
  "选择优惠券弹出层": "Sélection de la fenêtre contextuelle de coupon",
  "您已经选择了十五张优惠券，若要更换请删除其他优惠券！": "Vous avez déjà sélectionné quinze coupons, veuillez en supprimer d'autres si vous souhaitez les remplacer!",
  "产品编码": "Code produit",
  "请填写产品编码": "Veuillez indiquer le code produit",
  "产品划线价": "Prix de liste du produit",
  "请填写产品划线价": "Veuillez indiquer le prix de liste du produit",
  "商品重量": "Poids du produit",
  "请填写商品重量": "Veuillez indiquer le poids du produit",
  "批量设置": "Paramètres en vrac",
  "划线价": "Prix de liste",
  "重量": "Poids",
  "应用": "Appliquer",
  "规格图片": "Image de spécification",
  "规格值": "Valeur de spécification",
  "请输入规格值": "Veuillez indiquer la valeur de spécification",
  "请填写规则名或规则值": "Veuillez indiquer le nom ou la valeur de la règle",
  "规格值不能为空": "La valeur de spécification ne peut pas être vide",
  "卡名称": "Nom de la carte",
  "卡ID": "Identifiant de la carte",
  "无": "Aucun",
  "选择会员": "Sélectionner le membre",
  "恭喜你，发卡成功": "Félicitations, la délivrance de la carte a réussi",
  "副卡数": "Nombre de cartes supplémentaires",
  "张": "pièces",
  "选择日期": "Sélectionner une date",
  "签到设置": "Paramètres de check-in",
  "签到记录": "Enregistrements de check-in",
  "是否开启签到有礼": "Activer les récompenses de check-in",
  "每日签到固定奖励": "Récompense fixe pour les check-ins quotidiens",
  "每日签到送": "Récompense de check-in quotidienne",
  "递增奖励": "Récompense croissante",
  "有": "Oui",
  "第二天起递增奖励": "Récompense croissante débutant au deuxième jour",
  "请输入第二天起递增积分数": "Veuillez indiquer les points supplémentaires débutant à partir du deuxième jour",
  "第": "Jour",
  "请输入第几天不再递增": "Indiquez le jour où l'augmentation s'arrête",
  "天起不再递增": "Pas d'augmentation à partir de ce jour",
  "连续签到额外奖励 （达到额外奖励最大天数时，继续签到不会再获得额外奖励，断签后重新开始计算）": "Récompenses supplémentaires pour les check-ins consécutifs (Lorsqu'on atteint le nombre maximal de jours de récompenses supplémentaires, d'autres check-ins ne recevront plus de récompenses supplémentaires ; le compte recommence après un check-in manqué)",
  "额外奖励": "Récompense supplémentaire",
  "连续签到": "Check-ins consécutifs",
  "请输入连续签到天数": "Veuillez indiquer le nombre de jours de check-ins consécutifs",
  "积分奖励": "Récompenses en points",
  "送": "offrir",
  "请输入连续签到天数的积分": "Veuillez fournir les points pour les jours de check-in consécutifs",
  "规则": "Règles",
  "规则说明": "Explication des règles",
  "请添加至少一项额外奖励！": "Veuillez ajouter au moins une récompense supplémentaire !",
  "天数不能为空！": "Les jours ne peuvent pas être vides !",
  "请输入连续签到积分数！": "Veuillez indiquer les points pour les check-ins consécutifs !",
  "每日签到送积分有误": "Erreur dans les points de check-in quotidiens",
  "恭喜你，保存成功": "Félicitations, sauvegarde réussie",
  "连续签到天数": "Jours de check-ins consécutifs",
  "不限": "Illimité",
  "签到时间": "Heure de check-in",
  "时间": "Temps",
  "请输入用户昵称": "Veuillez entrer le pseudo de l'utilisateur",
  "签到日期": "Date de check-in",
  "活动奖品": "Prix d'activité",
  "取号记录": "Enregistrements de réservation de numéro",
  "桌号管理": "Gestion des tables",
  "取号设置": "Paramètres de réservation de numéro",
  "请输入手机号": "Veuillez entrer le numéro de téléphone",
  "待叫号": "à appeler",
  "就餐号": "Numéro de repas",
  "就餐人数": "Nombre de convives",
  "桌位名称": "Nom de la table",
  "取号时间": "Heure de réservation de numéro",
  "待取号": "à réserver",
  "已入座": "Assis",
  "已过号": "Manqué",
  "已取消": "Annulé",
  "是否开启打印": "Activer l'impression",
  "须知": "Directives",
  "请输入须知": "Veuillez entrer les directives",
  "商家说明": "Description du commerçant",
  "请输入商家说明": "Veuillez fournir la description du commerçant.",
  "取号规则": "Règles de réservation de numéro",
  "等待时间": "Temps d'attente",
  "人数最小值": "Nombre minimal de personnes",
  "人数最大值": "Nombre maximal de personnes",
  "等待时间(分钟)": "Temps d'attente (minutes)",
  "请输入桌位名称": "Veuillez entrer le nom de la table",
  "请输入人数最小值": "Veuillez indiquer le nombre minimum de personnes",
  "请输入人数最大值": "Veuillez indiquer le nombre maximum de personnes",
  "请输入等待时间": "Veuillez indiquer le temps d'attente",
  "商品设置": "Paramètres de produits",
  "兑换记录": "Enregistrements de conversion",
  "活动名称": "Nom de l'activité",
  "请输入活动名称": "Veuillez entrer le nom de l'activité",
  "活动列表": "Liste des activités",
  "添加活动": "Ajouter une activité",
  "活动价格": "Prix de l'activité",
  "发放数量": "Quantité distribuée",
  "参与人数": "Nombre de participants",
  "终止": "Arrêter",
  "购买记录": "Enregistrements d'achat",
  "新增活动会场": "Ajouter un nouvel emplacement d'activité",
  "活动标题": "Titre de l'activité",
  "请输入活动标题": "Veuillez saisir le titre de l'activité",
  "活动日期": "Date de l'activité",
  "礼包设置": "Configuration du package cadeau",
  "优惠券id": "ID du coupon",
  "购买设置": "Paramètres d'achat",
  "购买金额": "Montant d'achat",
  "会员购买等级": "Niveau d'achat des membres",
  "指定等级": "Niveau désigné",
  "购买次数": "Fréquence d'achat",
  "限购": "Limite d'achat",
  "每人限购": "Limite d'achat par personne",
  "次": "Fois",
  "发放设置": "Paramètres de distribution",
  "请输入发放数量": "Veuillez entrer la quantité à distribuer",
  "返回": "Retour",
  "请勿重复添加": "Veuillez éviter les ajouts en double",
  "至少选择一个优惠券": "Veuillez sélectionner au moins un coupon",
  "新增活动": "Ajouter une nouvelle activité",
  "券包设置": "Paramètres du pack de coupons",
  "下载推广码": "Télécharger le code promo",
  "使用该功能前，需前往小程序后台，在“设置”-“接口设置”-“公众号关注组件”中设置要展示的公众号。注：设置的公众号需与小程序主体一致": "Avant d'utiliser cette fonction, accédez à l'arrière-plan de la mini-application, et dans 'Paramètres'-'Paramètres de l'interface'-'Composant de suivi de compte public', définissez le compte public à afficher. Remarque : Le compte public configuré doit correspondre à l'entité de la mini-application",
  "去配置": "Aller à la configuration",
  "若没有配置公众号，功能将不生效": "Si aucun compte public n'est configuré, la fonction ne sera pas activée",
  "在一个小程序的生命周期内，只有从以下场景进入小程序，才具有展示引导关注公众号的能力": "Durant le cycle de vie d'une mini-application, seule l'entrée depuis les scènes suivantes permet d'activer la capacité à afficher et guider le suivi du compte public",
  "当小程序从扫小程序码打开时": "Lorsque la mini-application est ouverte en scannant le code de la mini-application",
  "当从其他小程序返回小程序时，若小程序之前未被销毁，则该组件保持上一次打开小程序时的状态": "Lors du retour à la mini-application depuis une autre mini-application, si la précédente mini-application n'a pas été détruite, le composant conservera l'état de la dernière ouverture de la mini-application",
  "公众号关注": "Abonnement au compte public",
  "新客设置": "Configuration du nouveau client",
  "是否开启活动": "L'activité est-elle activée?",
  "活动时间": "Période de l'activité",
  "背景图": "Image de fond",
  "赠送优惠券": "Offre de coupons",
  "请选择优惠券": "Veuillez sélectionner un coupon",
  "赠送积分": "Offre de points",
  "请输入赠送积分": "Veuillez entrer les points à offrir",
  "直播同步": "Synchronisation de la diffusion en direct",
  "同步直播": "Synchroniser la diffusion en direct",
  "请输入直播间名称/主播昵称": "Veuillez entrer le nom de la salle de diffusion en direct/pseudo de l'hôte.",
  "直播间ID": "Identifiant de la salle de diffusion en direct",
  "直播间名称": "Nom de la salle de diffusion en direct",
  "主播昵称": "Pseudo de l'hôte",
  "直播开始时间": "Heure de début de la diffusion en direct",
  "直播结束时间": "Heure de fin de la diffusion en direct",
  "直播间状态": "état de la salle de diffusion en direct",
  "置顶": "épingler en haut",
  "未置顶": "Non épinglé",
  "已置顶": "épinglé",
  "设为置顶": "Définir en tant que haut de page",
  "取消置顶": "Détacher",
  "直播中": "Direct en cours",
  "未开始": "Pas encore commencé",
  "已结束": "Terminé",
  "禁播": "Interdiction de diffusion",
  "暂停": "En pause",
  "异常": "Anormal",
  "已过期": "Expiré",
  "置顶成功": "épinglé avec succès",
  "邀请活动": "événement d'invitation",
  "个人中心图片": "Image du centre personnel",
  "请输入用户昵称/手机号": "Veuillez entrer le pseudo de l'utilisateur/numéro de téléphone",
  "邀请人": "Personne invitante",
  "被邀请人": "Personne invitée",
  "参加时间": "Heure de participation",
  "个人中心显示": "Affichage du centre personnel",
  "参与记录": "Historique de participation",
  "礼品记录": "Historique des cadeaux",
  "推广二维码": "Code QR de promotion",
  "编辑活动会场": "Modifier le lieu de l'événement",
  "请输入分享标题": "Veuillez entrer le titre de partage",
  "请输入分享内容": "Veuillez entrer le contenu du partage",
  "分享内容": "Contenu de partage",
  "分享图": "Image de partage",
  "个人中心状态": "état du centre personnel",
  "邀请成功的条件": "Conditions de réussite de l'invitation",
  "邀请成为会员": "Inviter à devenir membre",
  "邀请成为会员且消费": "Inviter à devenir membre et à consommer",
  "礼品设置": "Paramètres des cadeaux",
  "奖项": "Prix",
  "每邀请": "Par invitation",
  "人获得礼品": "Personne recevant un cadeau",
  "添加奖励项": "Ajouter un item de récompense",
  "请上传背景图": "Veuillez télécharger une image de fond",
  "请上传分享图": "Veuillez télécharger une image de partage",
  "请添加奖项": "Veuillez ajouter un prix",
  "开启首页推送": "Activer la notification sur la page d'accueil",
  "建议换活动，此名称更换，商城首页弹窗根据此名称不同来弹窗": "Il est recommandé de changer l'activité ; le changement de ce nom ajustera la fenêtre contextuelle sur la page d'accueil du centre commercial en fonction de ce nom",
  "类型": "Type",
  "图文": "Image et texte",
  "纯图": "Image pure",
  "领取优惠券": "Récupérer le coupon",
  "请输入标题": "Veuillez entrer un titre",
  "弹窗图片": "Image de la fenêtre contextuelle",
  "图片为2M以内大小，格式限png，jpg格式": "La taille de l'image doit être inférieure à 2 Mo et aux formats PNG ou JPG",
  "按钮文案": "Texte du bouton",
  "简介说明": "Explication succincte",
  "请输入说明": "Veuillez entrer une explication",
  "点击选择你要链接的位置": "Cliquez pour sélectionner l'emplacement de votre lien",
  "跳转地址": "Adresse de redirection",
  "最多可以添加三张": "Maximum Trois Ajouts Autorisés",
  "最多添加3张优惠券": "Limite Maximale d'Ajout : 3 Coupons",
  "标题不能为空": "Le Titre Ne Peut Pas être Vide",
  "请选择跳转链接": "Sélectionnez le Lien de Redirection",
  "请选择优惠卷": "Sélectionnez le Coupon",
  "请上传图片": "Veuillez Télécharger une Image",
  "团购订单": "Commandes d'Achat en Groupe",
  "团购管理": "Gestion des Achats en Groupe",
  "团购设置": "Réglages des Achats en Groupe",
  "订单设置": "Réglages de Commande",
  "未支付订单": "Commandes Non Payées",
  "请输入关闭时间": "Veuillez Entrer l'Heure de Fermeture",
  "分钟后自动关闭": "Fermeture Automatique Après Minutes",
  "订单下单未付款，n分钟后自动关闭，设置0不自动关闭": "Les Commandes sans Paiement se Ferment Automatiquement Après n Minutes ; Mettez 0 pour Aucune Fermeture Automatique",
  "团购保障": "Assurance des Achats en Groupe",
  "使用门店": "Utilisation en Magasin",
  "待付款": "Paiement en Attente",
  "待使用": "En Attente d'Utilisation",
  "已退款": "Remboursé",
  "使用门店名称": "Nom du Magasin pour l'Utilisation",
  "门店联系人": "Contact du Magasin",
  "门店电话": "Numéro de Téléphone du Magasin",
  "团购信息": "Informations d'Achat en Groupe",
  "券码信息": "Informations de Code de Coupon",
  "核销券码": "échanger le Code du Coupon",
  "添加团购": "Ajouter un Achat en Groupe",
  "团购名称": "Nom de l'Achat en Groupe",
  "销售价格": "Prix de Vente",
  "虚拟销量": "Volume de Ventes Virtuelles",
  "部分": "Partiel",
  "基础设置": "Configuration de Base",
  "购买须知": "Directives d'Achat",
  "团购详情": "Détails de l'Achat en Groupe",
  "团购须知": "Directives d'Achat en Groupe",
  "请输入团购名称": "Veuillez Entrer le Nom de l'Achat en Groupe",
  "到期类型": "Type de Perte de Validité",
  "购买后生效": "Effet Post-Achat",
  "固定时间": "Temps Fixe",
  "有效天数": "Période de Validité en Jours",
  "请输入有效天数": "Veuillez Entrer la Période de Validité en Jours",
  "有效时间": "Temps Valide",
  "请输入有效时间": "Veuillez Entrer le Temps Valide",
  "团购图片": "Image de l'Achat en Groupe",
  "请上传团购图片": "Veuillez Télécharger l'Image de l'Achat en Groupe",
  "请输入划线价格": "Veuillez Entrer le Prix Barré",
  "请输入销售价格": "Veuillez Entrer le Prix de Vente",
  "请输入虚拟销量": "Veuillez Indiquer le Volume de Ventes Virtuelles",
  "适用门店": "Magasins Applicables",
  "请选择门店": "Sélectionnez le Magasin",
  "团购状态": "état de l'Achat en Groupe",
  "每日限购数量": "Limite d'Achat Quotidienne",
  "每个会员每日购买的最大数量，0为不限购": "Quantité Maximale Quotidienne par Membre ; 0 pour Aucune Limite",
  "商家名称": "Nom du Marchand",
  "平台": "Plateforme",
  "满类型": "Type de Seuil",
  "满额": "Montant Minimum",
  "满件数": "Nombre Minimum",
  "满值": "Valeur du Seuil",
  "减类型": "Type de Réduction",
  "减金额": "Montant de Réduction",
  "打折": "Remise",
  "减值": "Valeur de Réduction",
  "编辑活动": "Modifier l'Activité",
  "满金额": "Montant Minimum",
  "请输入满值": "Veuillez Indiquer la Valeur du Seuil",
  "如果是打折，填写80，表示打8折": "Pour une Remise, Entrez 80 pour 20% de Réduction",
  "满额免配送费设置": "Frais de Livraison Gratuits sur un Seuil",
  "是否开启满额免配送费": "Activer les Frais de Livraison Gratuits sur un Seuil",
  "单笔订单满": "Commande Unique Dépasse",
  "如果开启满额免配送费，设置0为全场免配送费": "Si les Frais de Livraison sont Gratuits, Mettez 0 pour Toute la Commande",
  "入驻申请": "Demande d'Installation",
  "配送员": "Livreur",
  "配送订单": "Commandes de Livraison",
  "提现申请": "Demande de Retrait",
  "配送设置": "Paramètres de Livraison",
  "退出申请": "Demande de Sortie",
  "正常": "Normal",
  "押金": "Dépôt",
  "累计佣金": "Commission Cumulée",
  "可提现佣金": "Commission Disponible pour le Retrait",
  "已提现佣金": "Commission Déjà Retirée",
  "提现明细": "Détails de Retrait",
  "申请条件": "Conditions de Demande",
  "结算": "Règlement",
  "是否开启押金支付": "Activer le paiement du dépôt",
  "是否审核": "Exiger une Vérification",
  "需后台审核": "Vérification Requise en Arrière-Plan",
  "无需审核": "Pas de Vérification Nécessaire",
  "产品列表弹出层": "Liste de Produits en Superposition",
  "已选择该商品": "Produit Déjà Sélectionné",
  "注：如使用微信支付，则需申请微信支付企业付款到零钱功能": "Remarque : Pour WeChat Pay, demander le transfert direct vers le solde",
  "微信提现方式": "Mode de Retrait WeChat",
  "微信提现到零钱": "Retrait vers le Portefeuille WeChat",
  "商家转账到零钱": "Transférer au Portefeuille du Marchand",
  "注：根据实际产品开通情况选择": "Choisir en Fonction de l'Activation du Produit sur le Terrain",
  "最低提现额度": "Plafond de Retrait Minimum",
  "佣金结算时间": "Temps de Règlement de Commission",
  "注：当订单完成n小时后，该订单的配送佣金才会结算到配送员余额，如果设置为0小时，则订单完成时就结算": "Remarque : Les commissions de livraison se règlent sur le compte du livreur n heures après la commande complète ; Mettre à 0 pour un règlement immédiat",
  "请至少选择一种提现方式": "Veuillez Sélectionner au Moins un Mode de Retrait",
  "佣金结算": "Règlement de Commission",
  "是否结算佣金": "La Commission Doit-elle être Réglée?",
  "已结算": "Réglé",
  "未结算": "Pas Réglé",
  "送达状态": "état de Livraison",
  "查看详情": "Voir les Détails",
  "该操作将使用微信支付企业付款到零钱功能，确定打款吗？": "Cette Opération Utilisera le Paiement d'Entreprise WeChat vers votre Solde. Confirmez-vous la Transaction?",
  "身份证号": "Numéro d'Identification",
  "待交押金": "Depôt en attente",
  "审核方式": "Mode de Vérification",
  "查看": "Voir",
  "配送员审核": "Vérification du Livreur",
  "添加外卖商品": "Ajouter des Produits à Emporter",
  "序号": "Numéro",
  "活动折扣": "Remise d'Activité",
  "活动库存": "Stock d'Activité",
  "添加店内商品": "Ajouter des Produits en Magasin",
  "优惠券列表": "Liste de Coupons",
  "发送优惠券": "Envoyer des Coupons",
  "发送对象": "Destinataire",
  "全站会员": "Membres du Site",
  "指定会员": "Membre Designé",
  "选择会员等级": "Sélectionner le Niveau de Membre",
  "发送的优惠券会员领取已达到限制数量，将不再发送给该会员": "Le Destinataire a Atteint la Limite de Réception du Coupon Spécifié et ne le Recevra Plus",
  "发送成功": "Envoi Réussi",
  "优惠券ID": "ID du Coupon",
  "优惠券名称": "Nom du Coupon",
  "优惠券类型": "Type de Coupon",
  "最低消费金额": "Montant Minimum d'Achat",
  "优惠方式": "Méthode de Réduction",
  "立减": "Réduction Immédiate",
  "打": "Remise",
  "领取": "Recevoir",
  "天内有效": "Valide pour jours",
  "发放总数量": "Quantité Totale de Distribution",
  "不限制": "Illimité",
  "已领取数量": "Quantité reçue",
  "修改优惠券": "Modifier le Coupon",
  "请输入优惠券名称": "Veuillez Entrer le Nom du Coupon",
  "例如：满100减10": "Par Exemple : Dépensez 100 et Obtenez 10 de Réduction",
  "优惠券颜色": "Couleur du Coupon",
  "蓝色": "Bleu",
  "红色": "Rouge",
  "紫色": "Violet",
  "黄色": "Jaune",
  "满减券": "Coupon de Réduction",
  "折扣券": "Coupon de Taux de Réduction",
  "减免金额": "Montant de Réduction",
  "请输入减免金额": "Veuillez Saisir le Montant de Réduction",
  "折扣率": "Taux de Réduction",
  "请输入折扣率": "Veuillez Indiquer le Taux de Réduction",
  "折扣率范围0-10，9.5代表9.5折，0代表不折扣": "Le Taux de Réduction va de 0 à 10 ; Par Exemple, 9.5 Pour 5% de Réduction, et 0 pour Aucune Réduction",
  "请输入最低消费金额": "Veuillez Indiquer le Montant Minimum d'Achat",
  "后生效": "Effet Postérieur",
  "请输入发放总数量": "Veuillez Indiquer la Quantité Totale de Distribution",
  "限制领取的优惠券数量，-1为不限制": "Limiter le Nombre de Coupons Recevables, -1 pour Aucune Limite",
  "是否显示在领券中心": "Est-ce Affiché dans le Centre de Coupons?",
  "新用户首次进入小程序的时候才会显示如图所示的弹窗提示，只显示一次": "La boîte de dialogue illustrée ne s'affiche que lorsque le nouvel utilisateur entre dans l'application pour la première fois, et ce, une seule fois.",
  "引导收藏": "Collection Guidée",
  "编辑类型": "Type d'édition",
  "生日设置": "Paramètres de l'Anniversaire",
  "手机短信": "SMS sur Mobile",
  "分销商用户": "Utilisateur de Distributeur",
  "分销订单": "Commandes de Distribution",
  "分销海报": "Affiches de Distribution",
  "推荐人": "Parrain",
  "下级用户": "Utilisateurs Inférieurs",
  "一级": "Niveau Un",
  "二级": "Niveau Deux",
  "三级": "Niveau Trois",
  "成为时间": "Date de Devenu Membre",
  "下级": "Inférieur",
  "加入时间": "Date de Join",
  "分销商条件": "Conditions de Distributeur",
  "佣金设置": "Réglages de Commission",
  "自定义文字": "Texte Personnalisé",
  "申请协议": "Contrat de Demande",
  "页面背景图": "Image de Fond de Page",
  "分销中心页面": "Page du Centre de Distribution",
  "页面标题": "Titre de Page",
  "分销中心": "Centre de Distribution",
  "非分销商提示": "Conseil pour Non-Distributeur",
  "您还不是分销商，请先提交申请": "Vous N'êtes Pas Encore un Distributeur, Veuillez Soumettre une Demande",
  "申请成为分销商": "Demander à Devenir Distributeur",
  "立即加入": "Rejoindre Maintenant",
  "可提现": "Retrait Possible",
  "待提现佣金": "Commission en Attente de Retrait",
  "待提现": "En Attente de Retrait",
  "已提现金额": "Montant Déjà Retiré",
  "去提现": "Retirer",
  "申请成为分销商页面": "Page de Demande de Distribution",
  "请填写申请信息": "Veuillez Remplir les Informations de Demande",
  "分销商申请协议": "Contrat de Demande du Distributeur",
  "申请成为经销商": "Demander à Devenir un Revendeur",
  "审核中提示信息": "Notification d'Examen en Cours",
  "您的申请已受理，正在进行信息核验，请耐心等待。": "Votre demande a été reçue et est en cours de vérification des informations. Veuillez patienter.",
  "去商城逛逛": "Faire des Achats dans le Centre Commercial",
  "分销订单页面": "Page de Commandes de Distribution",
  "我的团队页面": "Page de Mon équipe",
  "我的团队": "Mon équipe",
  "团队总人数": "Nombre Total de Membres de l'équipe",
  "一级团队": "équipe Principale",
  "二级团队": "équipe Secondaire",
  "三级团队": "équipe Tertiaire",
  "提现明细页面": "Page des Détails de Retrait",
  "审核中": "En Cours de Vérification",
  "申请提现页面": "Page de Demande de Retrait",
  "申请提现": "Déposer une Demande de Retrait",
  "请输入要提取的金额": "Veuillez Indiquer le Montant à Retirer",
  "最低提现佣金": "Commission de Retrait Minimum",
  "提交申请": "Soumettre la Demande",
  "佣金结算天数": "Jours de Règlement de Commission",
  "注：当订单完成n天后，该订单的分销佣金才会结算到分销商余额，如果设置为0天,则订单完成时就结算": "Remarque : Les commissions de distribution se règlent sur le compte du distributeur n jours après la commande complétée ; Mettez 0 pour un règlement immédiat",
  "成为分销商条件": "Critères de Devenir Distributeur",
  "购买指定商品成为分销商": "Devenir Distributeur en Achetant des Produits Désignés",
  "购买指定商品付款后自动成为分销商，无需后台审核": "Devenir Automatiquement Distributeur Après l'Achat de Produits Désignés, Aucune Vérification Nécessaire",
  "选择商品": "Sélectionner des Produits",
  "成为下线条件": "Critères pour Devenir Subordonné",
  "首次点击分享链接": "Premier Clic sur le Lien de Partage",
  "一级佣金比例": "Taux de Commission de Niveau Un",
  "佣金比例范围 0% - 100%": "Taux de Commission entre 0% et 100%",
  "二级佣金比例": "Taux de Commission de Niveau Deux",
  "三级佣金比例": "Taux de Commission de Niveau Trois",
  "是否开启分销功能": "Activer la Fonction de Distribution",
  "分销层级": "Niveaux de Distribution",
  "一级分销": "Distribution de Niveau Un",
  "二级分销": "Distribution de Niveau Deux",
  "三级分销": "Distribution de Niveau Trois",
  "分销商内购": "Achat Interne de Distributeur",
  "如开启，分销商自己购买商品，获得一级佣金": "If enabled, distributors receive primary commission for purchases made by themselves",
  "分销中心首页": "Page d'Accueil du Centre de Distribution",
  "尺寸：宽750像素 高度227像素": "Dimensions : Largeur 750 pixels, Hauteur 227 pixels",
  "申请成为分销商页": "Page de Demande pour Devenir Distributeur",
  "申请提现页": "Page de Demande de Retrait",
  "分销海报设置": "Réglages d'Affiches de Distribution",
  "海报背景图": "Image d'Arrière-plan de l'Affiche",
  "尺寸：宽750像素 高大于(等于)1200像素": "Dimensions : Largeur 750 pixels, Hauteur supérieure ou égale à 1200 pixels",
  "头像宽度": "Largeur de l'Avatar",
  "头像样式": "Style de l'Avatar",
  "正方形": "Carré",
  "圆形": "Rond",
  "昵称字体大小": "Taille de Police du Pseudo",
  "昵称字体颜色": "Couleur de Police du Pseudo",
  "小程序码宽度": "Largeur du Code du Mini Programme",
  "小程序码样式": "Style du Code du Mini Programme",
  "分销商": "Distributeur",
  "一级分销商": "Distributeur Principal",
  "用户": "Utilisateur",
  "分销佣金": "Commission du Distributeur",
  "二级分销商": "Distributeur Secondaire",
  "三级分销商": "Distributeur Tertiaire",
  "分销商审核": "Examen du Distributeur",
  "积分明细": "Détails des Points",
  "变动数量": "Changements de Quantité",
  "积分名称": "Nom des Points",
  "例": "Exemple",
  "修改积分名称后，在买家端的所有页面里，看到的都是自定义的名称": "Après avoir modifié le nom des points, le nom personnalisé sera affiché sur toutes les interfaces destinées aux acheteurs",
  "商家使用自定义的积分名称来做品牌运营。如京东把积分称为“京豆”，淘宝把积分称为“淘金币”": "Les entreprises utilisent des noms de points personnalisés pour le branding. Par exemple, JD appelle les points 'Haricots JD' et Taobao les appelle 'Pièces au Trésor'",
  "积分说明": "Description des Points",
  "积分赠送": "Don de Points",
  "是否开启购物送积分": "Activer le Don de Points pour les Achats",
  "积分赠送规则": "Règles de Don de Points",
  "如开启则订单完成后赠送用户积分": "Si activé, des points sont attribués aux utilisateurs à la fin de la commande",
  "订单确认收货已完成": "Confirmation de la Commande et Réception Terminées",
  "已完成订单超出后台设置的申请售后期限": "Les commandes terminées dépassent la période de post-vente définie dans le backend",
  "积分赠送比例": "Ratio de Don de Points",
  "赠送比例请填写数字0~100；订单的运费不参与积分赠送": "Veuillez saisir un ratio entre 0 et 100 ; les frais de livraison ne sont pas inclus dans le don de points",
  // =====================  营销工具end   ==========

  // =====================  数据统计 start   ==========
  "销售统计": "Statistiques de vente",
  "会员统计": "Statistiques des membres",
  "订单概况": "Aperçu des commandes",
  "商品概况": "Aperçu des produits",
  "今日": "Aujourd'hui",
  "累积会员数": "Nombre total de membres",
  "新增会员数": "Nouveaux membres",
  "成交会员数": "Membres ayant effectué des transactions",
  "排行榜": "Classement",
  "用户消费榜": "Classement des dépenses des utilisateurs",
  "积分排行榜": "Classement des points",
  "邀请人排行榜": "Classement des invités",
  "成交会员占比": "Ratio de membres ayant effectué des transactions",
  "今天": "Aujourd'hui",
  "最近7天": "Les 7 derniers jours",
  "最近30天": "Les 30 derniers jours",
  "最近90天": "Les 90 derniers jours",
  "最近180天": "Les 180 derniers jours",
  "最近1年": "L'année écoulée",
  "最近2年": "Les 2 dernières années",
  "所有占比": "Ratio global",
  "成交会员": "Membres ayant effectué des transactions",
  "未成交会员": "Membres n'ayant pas effectué de transaction",
  "新增会员": "Nouveaux membres",
  "最近一周": "La semaine dernière",
  "最近一个月": "Le mois dernier",
  "最近三个月": "Les trois derniers mois",
  "选择店铺": "Sélectionner le magasin",
  "查询日期": "Date de la requête",
  "近七天": "Les sept derniers jours",
  "近十五天": "Les quinze derniers jours",
  "自定义时间": "Temps personnalisé",
  "日期": "Date",
  "有效订单数": "Nombre de commandes valides",
  "选择时间": "Sélectionner le temps",
  "交易统计": "Statistiques des transactions",
  "订单数": "Nombre de commandes",
  "客单价": "Valeur moyenne de la commande",
  "付款订单": "Commandes payées",
  "付款人数": "Nombre de payeurs",
  "商品统计": "Statistiques des produits",
  "在售商品": "Produits disponibles",
  "件": "Article",
  "已付款商品": "Produits payés",
  "销量TOP10": "Top 10 des ventes",
  "浏览TOP10": "Top 10 des vues",
  "浏览": "Vue",
  "排行类型": "Type de classement",
  "商品总数": "Nombre total de produits",
  "已上架商品": "Produits en vente",
  "已下架商品": "Produits hors vente",
  "商品导出": "Exportation des produits",
  "商品总销量": "Volume total des ventes de produits",
  "商品总销售额": "Montant total des ventes de produits",
  "资产总览": "Aperçu des actifs",
  "财务对账": "Rapprochement financier",
  "交易记录": "Registres de transactions",
  "店铺结算": "Règlement de la boutique",
  "待结算金额": "Montant en attente de règlement",
  "已结算金额": "Montant réglé",
  "交易概况": "Aperçu des transactions",
  "外卖统计": "Statistiques à emporter",
  "店内统计": "Statistiques en magasin",
  "订单类型": "Type de commande",
  "应收金额": "Montant à recevoir",
  "实付金额": "Montant payé",
  "账户概况": "Aperçu du compte",
  "订单编号": "Numéro de commande",
  "支付状态": "état de paiement",
  "付款方式": "Méthode de paiement",
  "优惠": "Remise",
  "商户实际收入": "Revenu réel du commerçant",
  "商品ID": "Identifiant du produit",
  "小计": "Sous-total",
  "请输入提现金额": "Veuillez saisir le montant du retrait",
  "请输入打款方式": "Veuillez saisir la méthode de paiement",
  "支付宝真实姓名": "Nom réel Alipay",
  "请输入支付宝真实姓名": "Veuillez saisir le nom réel Alipay",
  "开户行名称": "Nom de la banque",
  "银行开户名": "Nom du compte bancaire",
  "真实姓名": "Nom réel",
  "应付金额": "Montant à payer",
  "实付总额": "Montant total payé",
  "商户": "Commerçant",
  "结算金额": "Montant du règlement",
  "店铺结算金额": "Montant du règlement du magasin",
  "操作提示": "Conseils d'opération",
  "订单结算金额 = 店铺结算总金额(含运费)": "Montant du règlement de la commande = Montant total du règlement de la boutique (frais de livraison inclus)",
  "店铺收入金额 = 店铺结算总金额 - 店铺退款金额": "Le montant des recettes du magasin = le montant total du règlement du magasin - le montant des remboursements du magasin",
  "订单日期": "Date de la commande",
  "订单结算金额": "Montant du règlement de la commande",
  "配送费金额": "Montant des frais de livraison",
  "商品编码": "Code du produit",
  "可用余额": "Solde disponible",
  "提现概况": "Aperçu des retraits",
  "搜索": "Chercher",
  "支出": "Dépense",
  "金额": "Montant",
  "收支类型": "Type de revenu et de dépenses",
  "确认要退吗?": "Confirmer le retour?",
  "申请成功": "Demande acceptée",
  "门店总金额": "Montant total du magasin",
  "累计收入": "Revenu cumulé",
  "访客数": "Nombre de visiteurs",
  "访问量": "Volume de visites",
  "店铺收藏数": "Nombre de favoris du magasin",
  "商品收藏数": "Nombre de favoris de produits",
  "访问数": "Nombre de visites",
  "收藏数": "Nombre de favoris",
  "数": "Nombre",
  "待支付": "En attente de paiement",
  "实际到账": "Montant réellement reçu",
  // =====================  数据统计 end   ==========

  // ==================== 设置 start ================
  "物流公司": "Compagnie de logistique",
  "chatgpt设置": "Paramètres de ChatGPT",
  "消息设置": "Paramètres de messagerie",
  "短信设置": "Paramètres SMS",
  "上传设置": "Paramètres de téléchargement",
  "清理缓存": "Effacer le cache",
  "网址后缀英文名称": "Nom anglais pour le suffixe du site web",
  "英文名称": "Nom anglais",
  "默认头像": "Avatar par défaut",
  "英文名称必须只包含数字和英文字母": "Le nom anglais ne doit contenir que des chiffres et des lettres",
  "恭喜你，商城设置成功": "Félicitations, les paramètres du magasin ont été appliqués avec succès",
  "表单数据不符合规则": "Les données du formulaire ne respectent pas les règles",
  "剩余额度": "Limite restante",
  "余额不足时，智能客服、AI魔法创建、多语言翻译等功能将无法使用": "Quand le solde est insuffisant, des fonctionnalités telles que le Service client intelligent, la Création de magie AI et la Traduction multilingue seront désactivées",
  "使用明细": "Détails d'utilisation",
  "消费": "Dépense",
  "额度": "Quota",
  "数据缓存": "Cache de données",
  "恭喜你，清理成功": "Félicitations, le processus de nettoyage a réussi",
  "管理员列表": "Liste des administrateurs",
  "角色管理": "Gestion des rôles",
  "登录日志": "Journal de connexion",
  "操作日志": "Journal des opérations",
  "添加管理员": "Ajouter un administrateur",
  "管理员ID": "ID de l'administrateur",
  "用户名": "Nom d'utilisateur",
  "所属角色": "Rôle attribué",
  "超级管理员": "Super Administrateur",
  "所属门店": "Magasin affilié",
  "门店状态": "état du magasin",
  "已删除": "Supprimé",
  "未删除": "Non supprimé",
  "账号状态": "état du compte",
  "恭喜你，该管理员删除成功": "Félicitations, l'administrateur a été supprimé avec succès",
  "请输入用户名": "Veuillez saisir le nom d'utilisateur",
  "修改管理员": "Modifier l'administrateur",
  "添加角色": "Ajouter un rôle",
  "角色ID": "ID du rôle",
  "角色名称": "Nom du rôle",
  "恭喜你，该角色删除成功": "Félicitations, le rôle a été supprimé avec succès.",
  "编辑角色": "Modifier le rôle",
  "请输入角色名称": "Veuillez saisir le nom du rôle",
  "权限列表": "Liste des autorisations",
  "请输入用户名和真实姓名": "Veuillez saisir le nom d'utilisateur et le vrai nom",
  "登录状态": "état de connexion",
  "全部标记为已读": "Marquer tout comme lu",
  "公告详情": "Détails de l'annonce",
  "全部标记为已读消息吗?": "Marquer tous les messages comme lus?",
  "操作成功!": "Opération réussie !",
  "已取消操作": "Opération annulée",
  "订单流程设置": "Paramètres du processus de commande",
  "已支付订单": "Commandes payées",
  "分钟后自动核销": "validation automatique après minutes",
  "如果在期间未核销，系统自动完成核销，设置0不自动核销": "Si non validé pendant cette période, le système validera automatiquement, définir à 0 pour ne pas valider automatiquement",
  "积分商城订单流程设置": "Paramètres du processus de commande du magasin de points",
  "已发货订单": "Commandes expédiées",
  "天后自动核销": "validation automatique après jours",
  "不包括桌台订单": "excluant les commandes de table",
  "恭喜你，交易设置成功": "Félicitations, les paramètres de transaction ont été appliqués avec succès",
  // ==================== 设置 end ================
  // ==================== Layout start ===========
  "当前版本": "Version actuelle",
  "试用版": "Version d'essai",
  "专业版": "édition professionnelle",
  "高级版": "édition avancée",
  "至尊版": "édition suprême",
  "到期日期": "Date d'expiration",
  "永不过期": "Ne jamais expirer",
  "欢迎您": "Bienvenue",
  "修改密码": "Changer le mot de passe",
  "此操作将退出登录, 是否继续?": "Cette opération vous déconnectera, voulez-vous continuer?",
  "原始密码": "Mot de passe d'origine",
  "新密码": "Nouveau mot de passe",
  "确认新密码": "Confirmer le nouveau mot de passe",
  "系统公告": "Annonce système",
  "请至少选择一件产品商品！": "Veuillez sélectionner au moins un produit!",
  "超链接设置": "Paramètres de l'hyperlien",
  "图像预览": "Aperçu de l'image",
  "页面": "Page",
  "当前链接": "Lien actuel",
  "暂无": "Aucun",
  "页面路径": "Chemin de la page",
  "注意一": "Note un",
  "注意二": "Note deux",
  "注意三": "Note trois",
  "同一个小程序链接其他小程序，最多只能链接10个，超过将不生效": "Pour le même mini-programme lié à d'autres mini-programmes, un maximum de 10 liens est autorisé; dépasser cette limite les rendra inefficaces",
  "不能填写自身小程序appid": "Impossible de remplir l'appid du mini-programme actuel",
  "小程序链接留空默认跳到小程序首页": "Laisser le lien du mini-programme vide le dirigera par défaut vers la page d'accueil du mini-programme",
  "分类": "Catégorie",
  "选择": "Sélectionner",
  "签到": "Se connecter",
  "积分商城": "Centre commercial de points",
  "秒杀": "Vente éclair",
  "拼团": "Achat groupé",
  "砍价": "Marchander",
  "领券中心": "Centre de coupons",
  "生日有礼": "Cadeau d'anniversaire",
  "链接的网页必须支持SSL ，链接必须以 https:// 开头，否则无法跳转": "La page web liée doit prendre en charge SSL et commencer par https://, sinon elle ne pourra pas être redirigée",
  "链接的域名必须是备案域名，否则无法跳转": "Le nom de domaine lié doit être un nom de domaine enregistré, sinon il ne pourra pas être redirigé",
  "您的网站域名必须加到微信小程序公众平台的业务域名处,详细说明？": "Votre nom de domaine doit être ajouté au domaine commercial de la plateforme publique des mini-programmes WeChat, pouvez-vous fournir plus de détails?",
  "选择文章列表": "Sélectionner la liste des articles",
  "文章标题": "Titre de l'article",
  "选择规格": "Sélectionner les spécifications",
  "产品/规格": "Produit/Spécifications",
  "已选": "Sélectionné",
  "查看物流": "Voir la logistique",
  "请输入收货人": "Veuillez saisir le destinataire",
  "请输入收获电话": "Veuillez saisir le numéro de téléphone du destinataire",
  "省": "Province",
  "市": "Ville",
  "区": "District",
  "现金收款": "Paiement en espèces",
  "余额收款": "Paiement du solde",
  "其他方式": "Autres méthodes",
  "请输入会员ID号查询会员，输入完毕后点击确认": "Veuillez saisir l'identifiant du membre pour rechercher le membre, puis cliquez sur Confirmer une fois terminé",
  "请输入会员ID": "Veuillez saisir l'identifiant du membre",
  "会员昵称": "Pseudo du membre",
  "余额总计": "Solde total",
  "登录会员仅作为积分累计，无法享受其他优惠": "Les membres connectés peuvent uniquement accumuler des points et ne peuvent pas bénéficier d'autres réductions",
  "取消收款": "Annuler le paiement",
  "收款": "Recevoir le paiement",
  "请输入会员手机号": "Veuillez saisir le numéro de téléphone du membre",
  "该用户不存在": "Cet utilisateur n'existe pas",
  "注册": "S'inscrire",
  "平台名称": "Nom de la plateforme",
  "请输入平台名称": "Veuillez saisir le nom de la plateforme",
  "所在地区": "Emplacement",
  "请选择所在地区": "Veuillez sélectionner l'emplacement",
  "平台账户名": "Nom du compte de la plateforme",
  "请输入平台账户名": "Veuillez saisir le nom du compte de la plateforme",
  "平台账户密码": "Mot de passe du compte de la plateforme",
  "是否连锁": "Est-ce une franchise ?",
  "请输入您的地址": "Veuillez saisir votre adresse",
  "请输入您的联系电话": "Veuillez saisir votre numéro de téléphone de contact",
  "请输入您的联系邮箱": "Veuillez saisir votre adresse e-mail de contact",
  "联系邮箱": "E-mail de contact",
  "不能全是空格": "Ne peut être que des espaces",
  "不能包含空格": "Ne peut contenir d'espaces",
  "长度不能小于6位": "La longueur ne peut être inférieure à 6 caractères",
  "请填写确认密码": "Veuillez entrer le mot de passe de confirmation",
  "确认密码不一致": "Les mots de passe ne correspondent pas",
  "联系电话和联系邮箱至少填写一个": "Veuillez fournir au moins un numéro de téléphone de contact ou une adresse e-mail",
  "注册成功,请前往登录": "Inscription réussie, veuillez procéder à la connexion",
  "清空": "Effacer",
  "确认": "Confirmer",
  "限时免费": "Gratuit pour une durée limitée",
  // ==================== Components end     =========

  // ==================== 其它  start  ================

  "菜品总量": "Total der Gerichte",
  "菜品排行榜": "Rangliste der Gerichte",
  "商家信息": "Informationen über den Händler",
  "与店内营业时间相同": "Identisch mit den Öffnungszeiten des Geschäfts",
  "菜品": "Gerichte",
  "菜品分类": "Gerichtskategorien",
  "添加菜品": "Ein Gericht hinzufügen",
  "通告": "Ankündigung",
  "商家店名": "Geschäftsname",
  "请输入商家店名": "Bitte geben Sie den Namen Ihres Geschäfts ein",
  "温馨提示：选择后，请勿随意修改，以免造成门店菜品数据错乱": "Herzlicher Hinweis: Bitte ändern Sie nach der Auswahl nicht willkürlich, um Datenprobleme bei den Geschäftsspeisen zu vermeiden",
  "网址后缀设置": "Einstellungen für URL-Suffix",
  "选填，设置后缀可替换下列网址末尾的数字id，方便记忆": "Optional, durch die Festlegung eines Suffixes kann dieser die numerische ID am Ende der folgenden URL ersetzen, um das Gedächtnis zu erleichtern",
  "网址设置": "URL-Einstellungen",
  "手机网站二维码": "QR-Code für die mobile Website",
  "按菜品收费": "Abrechnung nach Gericht",
  "外卖菜品": "Gerichte zum Mitnehmen",
  "店内菜品": "Gerichte für den Verkauf im Laden",
  "菜品管理": "Gerichtsverwaltung",
  "菜品名称": "Gerichtsname",
  "请输入菜品名称": "Bitte geben Sie den Namen des Gerichts ein",
  "此菜品正在参加活动，不能修改规格": "Dieses Gericht nimmt an einer Aktion teil und die Spezifikationen können nicht geändert werden",
  "通过人工智能技术，可以根据菜品名称自动填写菜品详细信息，如配料、卖点、口味等。": "Durch künstliche Intelligenz können basierend auf dem Gerichtsnamen automatisch detaillierte Informationen wie Zutaten, Verkaufsargumente und Geschmack eingetragen werden.",
  "请填写菜品详情": "Bitte geben Sie die Details des Gerichts ein",
  "菜品详情": "Details des Gerichts",
  "菜品图片": "Bild des Gerichts",
  "请上传菜品图片": "Bitte laden Sie ein Bild des Gerichts hoch",
  "AI未识别到您的菜品图片": "Die KI konnte Ihr Gerichtsbild nicht erkennen",
  "本菜品正在参加活动，不能删除规格！": "Dieses Gericht nimmt an einer Aktion teil, daher können die Spezifikationen nicht gelöscht werden",
  "菜品加料": "Zusatz zu Gerichten",
  "菜品状态": "Status des Gerichts",
  "选择菜品状态": "Gerichtsstatus wählen",
  "菜品排序": "Gerichtsreihenfolge",
  "请填写菜品名称": "Bitte geben Sie den Namen des Gerichts ein",
  "你选择菜品分类": "Sie haben eine Gerichtskategorie gewählt",
  "菜品卖点": "Verkaufsargumente des Gerichts",
  "菜品属性": "Eigenschaften des Gerichts",
  "菜品同步": "Synchronisation der Gerichte",
  "是否同步菜品至外卖": "Gerichte für den Lieferdienst synchronisieren",
  "是否同步菜品至店内": "Gerichte für den Einzelhandel synchronisieren",
  "搜索菜品": "Gerichte suchen",
  "菜品原价": "Ursprünglicher Preis des Gerichts",
  "菜品来源": "Herkunft des Gerichts",
  "菜品列表": "Liste der Gerichte",
  "菜品价格": "Preis des Gerichts",
  "菜品销量": "Verkaufszahlen des Gerichts",
  "通告管理": "Verwaltung von Ankündigungen",
  "添加通告": "Ankündigung hinzufügen",
  "通告ID": "Ankündigungs-ID",
  "通告标题": "Titel der Ankündigung",
  "通告分类": "Kategorie der Ankündigung",
  "通告排序": "Reihenfolge der Ankündigungen",
  "通告状态": "Status der Ankündigung",
  "通告内容": "Inhalt der Ankündigung",
  "编辑通告": "Ankündigung bearbeiten",
  "AI助理形象选择": "Auswahl des Bildes des AI-Assistenten",
  "菜品信息": "Informationen über das Gericht",
  "菜品总价": "Gesamtpreis der Gerichte",
  "请按实际店名填写，将显示在商家点餐网站上": "Bitte geben Sie den tatsächlichen Namen des Geschäfts ein, der auf der Restaurant-Website des Anbieters angezeigt wird",
  "首次添加桌位请先添加桌位类型": "Bei der ersten Hinzufügung einer Tischbelegung bitte zuerst einen Tischtyp hinzufügen",
  "首次添加桌位请先添加区域": "Bei der ersten Hinzufügung einer Tischbelegung bitte zuerst ein Gebiet hinzufügen",
  "设置店内区域，如A区、B区、大厅、包厢等": "Legen Sie die Bereiche im Laden fest, wie z.B. Bereich A, Bereich B, Lobby, Private Lounge, etc.",
  "设置桌位类型，如二人桌、四人桌、大桌、小桌等": "Legen Sie die Tischtypen fest, z.B. Zweiertisch, Vierertisch, Gro?er Tisch, Kleiner Tisch, etc.",
  "该账号用于登录收银台网站（可在“网址设置”页面找到收银台网址）": "Dieses Konto wird zur Anmeldung auf der Kassenseite verwendet (die URL zur Kassenseite finden Sie auf der Seite „URL-Einstellungen“)",
  "该账号用于登录后厨网站（可在“网址设置”页面找到后厨网址）": "Dieses Konto wird zur Anmeldung auf der Küchenseite verwendet (die URL zur Küchenseite finden Sie auf der Seite „URL-Einstellungen“)",
  "如无需设置税率可不填写": "Wenn keine Steuersatz-Einstellung erforderlich ist, muss dieses Feld nicht ausgefüllt werden",
  "打款信息": "Zahlungsinformationen",
  "开户行": "Bankname",
  "菜品分组": "Gruppierung der Gerichte",
  "自定义名称，仅用于商家自己区分分类，不会展示给顾客": "Benutzerdefinierter Name, der nur zur Unterscheidung der Kategorien durch den Händler dient und nicht für Kunden sichtbar ist",
  "手机网站编辑": "Bearbeitung der mobilen Website",
  "恢复初始默认页面": "Standardseite wiederherstellen",
  "通告为手机网站上展示的通知、公告、商家介绍等，“显示”状态时，该篇通告将展示在手机网站上": "Ankündigungen werden als Benachrichtigungen, Ankündigungen, Händlerinfos usw. auf der mobilen Website angezeigt. Wenn der Status auf „Anzeigen“ gesetzt ist, wird diese Ankündigung auf der mobilen Website erscheinen",
  "菜品重量": "Gewicht des Gerichts",
  "请填写菜品重量": "Bitte geben Sie das Gewicht des Gerichts ein",
  "菜品设置": "Einstellungen der Gerichte",
  "已选择该菜品": "Dieses Gericht wurde bereits ausgewählt",
  "添加外卖菜品": "Gericht für Lieferung hinzufügen",
  "添加店内菜品": "Gericht für den Verkauf im Laden hinzufügen",
  "购买指定菜品成为分销商": "Kauf von bestimmten Gerichten, um ein Vertriebspartner zu werden",
  "购买指定菜品付款后自动成为分销商，无需后台审核": "Automatisch Vertriebspartner werden, nachdem bestimmte Gerichte gekauft und bezahlt wurden, keine Überprüfung im Hintergrund erforderlich",
  "选择菜品": "Gerichtsauswahl",
  "如开启，分销商自己购买菜品，获得一级佣金": "Bei Aktivierung können Vertriebspartner Gerichte selbst kaufen und eine Erstkommissionsstufe erhalten",
  "订单付款金额(100.00€) * 积分赠送比例(100%) = 实际赠送的积分(100积分)": "Zahlungsbetrag der Bestellung (100,00€) * Prozentsatz für Punktevergabe (100%) = Tatsächlich vergebene Punkte (100 Punkte)",
  "菜品概况": "Überblick über die Gerichte",
  "菜品统计": "Statistiken der Gerichte",
  "在售菜品": "Verfügbare Gerichte",
  "已付款菜品": "Bezahlte Gerichte",
  "菜品总数": "Gesamtzahl der Gerichte",
  "已上架菜品": "Hochgeladene Gerichte",
  "已下架菜品": "Gestoppte Gerichte",
  "菜品导出": "Exportieren der Gerichte",
  "菜品总销量": "Gesamtverkauf der Gerichte",
  "菜品总销售额": "Gesamtumsatz der Gerichte",
  "菜品ID": "ID des Gerichts",
  "菜品编码": "Code des Gerichts",
  "菜品收藏数": "Anzahl der Gerichte als Favorit gespeichert",
  "请至少选择一件产品菜品！": "Wählen Sie bitte mindestens ein Produktgericht aus!",
  "区域管理": "Gestion de Zone",
  "点餐管理系统": "Système de Gestion des Commandes",
  "首页": "Page d'Accueil",
  "在地图中点击确认位置，坐标自动填入":"Cliquez pour confirmer l'emplacement sur la carte, et les coordonnées seront automatiquement remplies.",
  "添加优惠券请前往'营销工具'—'插件中心'—'优惠券'页面": "Pour ajouter un coupon, veuillez vous rendre à 'Marketing' - 'Outils marketing' - 'Coupon'.",
  // ==================== 其它  end    ================
  ...frLocale
}


export default fr



// WEBPACK FOOTER //
// ./src/i18n/langs/fr.js